// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   InputGroup,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Alert,
//   Pagination,
//   Image,
// } from "react-bootstrap";
// import axios from "axios";

// const ServitorDetails = () => {
//   const [servitors, setServitors] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResult, setSearchResult] = useState([]);

//   // View image
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [imageSrc, setImageSrc] = useState("");

//   const handleImageClick = (src) => {
//     setImageSrc(src);
//     setShowImageModal(true);
//   };

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // Edit Modal
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editServitor, setEditServitor] = useState(null);
//   const [formData, setFormData] = useState({
//     FirstName: "",
//     LastName: "",
//     email: "",
//     mobile: "",
//     NID: "",
//     dob: "",
//     gender: "",
//     service: "",
//     city: "",
//     Address: "",
//     experience: "",
//     approve_status: "",
//     balance: "",
//   });

//   useEffect(() => {
//     fetchServitors();
//   }, []);

//   const fetchServitors = async () => {
//     try {
//       const response = await axios.get("http://localhost:4001/servitors");
//       setServitors(response.data);
//     } catch (error) {
//       console.error("Error fetching servitors:", error);
//       setErrorMessage("Failed to fetch servitors. Please try again later.");
//     }
//   };

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     const filteredServitors = servitors.filter(
//       (servitor) =>
//         servitor.FirstName.toLowerCase().includes(value.toLowerCase()) ||
//         servitor.LastName.toLowerCase().includes(value.toLowerCase()) ||
//         servitor.email.toLowerCase().includes(value.toLowerCase()) ||
//         servitor.service.toLowerCase().includes(value.toLowerCase())
//     );
//     setSearchResult(filteredServitors);
//     setCurrentPage(1); // Reset to first page on new search
//   };

//   const handleEdit = (servitor) => {
//     setEditServitor(servitor);
//     setFormData({
//       FirstName: servitor.FirstName,
//       LastName: servitor.LastName,
//       email: servitor.email,
//       mobile: servitor.mobile,
//       NID: servitor.NID,
//       dob: servitor.dob.split("T")[0], // Format date for input
//       gender: servitor.gender,
//       service: servitor.service,
//       city: servitor.city,
//       Address: servitor.Address,
//       experience: servitor.experience,
//       approve_status: servitor.approve_status,
//       balance: servitor.balance ?? 0,
//     });
//     setShowEditModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this servitor?")) {
//       try {
//         await axios.delete(`http://localhost:4001/servitors/${id}`);
//         fetchServitors();
//         setErrorMessage("Servitor deleted successfully.");
//       } catch (error) {
//         console.error("Error deleting servitor:", error);
//         setErrorMessage("Failed to delete servitor. Please try again.");
//       }
//     }
//   };

//   const handleUpdate = async () => {
//     try {
//       const updateData = { ...formData };
//       // Handle image and DOC uploads if necessary
//       // This example assumes no image/DOC updates via this modal
//       await axios.put(
//         `http://localhost:4001/servitors/${editServitor.Id}`,
//         updateData
//       );
//       fetchServitors();
//       setShowEditModal(false);
//       setErrorMessage("Servitor updated successfully.");
//     } catch (error) {
//       console.error("Error updating servitor:", error);
//       setErrorMessage("Failed to update servitor. Please try again.");
//     }
//   };

//   // Pagination Logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentServitors = (searchTerm ? searchResult : servitors).slice(
//     indexOfFirstItem,
//     indexOfLastItem
//   );
//   const totalPages = Math.ceil(
//     (searchTerm ? searchResult.length : servitors.length) / itemsPerPage
//   );

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   return (
//     <Container>
//       {errorMessage && (
//         <Alert
//           variant={errorMessage.includes("successfully") ? "success" : "danger"}
//           onClose={() => setErrorMessage("")}
//           dismissible
//         >
//           {errorMessage}
//         </Alert>
//       )}
//       <Card className="shadow-sm">
//         <Card.Body>
//           <Card.Title className="mb-4">Servitor Details</Card.Title>
//           <Row className="mb-3">
//             <Col md={10}>
//               <InputGroup>
//                 <Form.Control
//                   placeholder="Search by name, email, or service"
//                   aria-label="searchBar"
//                   aria-describedby="basic-addon2"
//                   value={searchTerm}
//                   onChange={(e) => handleSearch(e.target.value)}
//                 />
//                 <InputGroup.Text id="basic-addon2">
//                   <i className="bi bi-search"></i>
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//           </Row>

//           {/* Use table-responsive to allow horizontal scrolling if needed */}
//           <div className="table-responsive">
//             <Table
//               striped
//               bordered
//               hover
//               responsive
//               className="table-sm"
//               style={{ fontSize: "12px", marginRight: "20px" }}
//             >
//               <thead>
//                 <tr>
//                   <th style={{ minWidth: "30px" }}>#</th>
//                   <th style={{ minWidth: "80px" }}>First Name</th>
//                   <th style={{ minWidth: "80px" }}>Last Name</th>
//                   <th style={{ minWidth: "80px" }}>Email</th>
//                   <th style={{ minWidth: "80px" }}>Mobile</th>
//                   <th style={{ minWidth: "80px" }}>Service</th>
//                   <th style={{ minWidth: "80px" }}>City</th>
//                   <th style={{ minWidth: "60px" }}>Experience</th>
//                   <th style={{ minWidth: "60px" }}>Balance</th>
//                   <th style={{ minWidth: "70px" }}>Image</th>
//                   <th style={{ minWidth: "70px" }}>DOC</th>
//                   <th style={{ minWidth: "70px" }}>Status</th>
//                   <th style={{ minWidth: "90px" }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentServitors.map((servitor, index) => (
//                   <tr key={servitor.Id}>
//                     <td className="p-2 text-muted">
//                       {index + 1 + indexOfFirstItem}
//                     </td>
//                     <td>{servitor.FirstName}</td>
//                     <td>{servitor.LastName}</td>
//                     <td>{servitor.email}</td>
//                     <td>{servitor.mobile}</td>
//                     <td>{servitor.service}</td>
//                     <td>{servitor.city}</td>
//                     <td>{servitor.experience} yrs</td>
//                     <td>{servitor.balance} Tk</td>
//                     <td>
//                       {servitor.image ? (
//                         <Image
//                           src={`http://localhost:4001/uploads/${servitor.image}`}
//                           alt={servitor.FirstName}
//                           rounded
//                           width="60"
//                           height="60"
//                           style={{ cursor: "pointer" }}
//                           onClick={() =>
//                             handleImageClick(
//                               `http://localhost:4001/uploads/${servitor.image}`
//                             )
//                           }
//                         />
//                       ) : (
//                         <Image
//                           src="/default-avatar.png"
//                           alt="Default Avatar"
//                           rounded
//                           width="60"
//                           height="60"
//                           style={{ cursor: "pointer" }}
//                           onClick={() =>
//                             handleImageClick("/default-avatar.png")
//                           }
//                         />
//                       )}
//                     </td>
//                     <td>
//                       {servitor.DOC ? (
//                         <a
//                           href={`http://localhost:4001/uploads/${servitor.DOC}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <i
//                             className="bi bi-file-earmark-pdf"
//                             style={{ fontSize: "1.5rem", color: "red" }}
//                           ></i>
//                         </a>
//                       ) : (
//                         <i
//                           className="bi bi-file-earmark"
//                           style={{ fontSize: "1.5rem" }}
//                         >
//                           {" "}
//                           N/A
//                         </i>
//                       )}
//                     </td>
//                     <td>{servitor.approve_status}</td>
//                     <td>
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           gap: "0.5rem",
//                         }}
//                       >
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           onClick={() => handleEdit(servitor)}
//                         >
//                           <i className="bi bi-pencil-square"></i>
//                         </Button>
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           onClick={() => handleDelete(servitor.Id)}
//                         >
//                           <i className="bi bi-trash3-fill"></i>
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>

//           {/* Pagination */}
//           <Pagination className="justify-content-center">
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* Edit Servitor Modal */}
//       <Modal
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Servitor</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formFirstName" className="mb-3">
//               <Form.Label>First Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="FirstName"
//                 value={formData.FirstName}
//                 onChange={(e) =>
//                   setFormData({ ...formData, FirstName: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formLastName" className="mb-3">
//               <Form.Label>Last Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="LastName"
//                 value={formData.LastName}
//                 onChange={(e) =>
//                   setFormData({ ...formData, LastName: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formEmail" className="mb-3">
//               <Form.Label>Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={(e) =>
//                   setFormData({ ...formData, email: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formMobile" className="mb-3">
//               <Form.Label>Mobile</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={(e) =>
//                   setFormData({ ...formData, mobile: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formNID" className="mb-3">
//               <Form.Label>NID</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="NID"
//                 value={formData.NID}
//                 onChange={(e) =>
//                   setFormData({ ...formData, NID: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formDOB" className="mb-3">
//               <Form.Label>Date of Birth</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="dob"
//                 value={formData.dob}
//                 onChange={(e) =>
//                   setFormData({ ...formData, dob: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formGender" className="mb-3">
//               <Form.Label>Gender</Form.Label>
//               <Form.Select
//                 name="gender"
//                 value={formData.gender}
//                 onChange={(e) =>
//                   setFormData({ ...formData, gender: e.target.value })
//                 }
//               >
//                 <option value="">Select Gender</option>
//                 <option value="Male">Male</option>
//                 <option value="Female">Female</option>
//                 <option value="Other">Other</option>
//               </Form.Select>
//             </Form.Group>
//             <Form.Group controlId="formService" className="mb-3">
//               <Form.Label>Service</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="service"
//                 value={formData.service}
//                 onChange={(e) =>
//                   setFormData({ ...formData, service: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formCity" className="mb-3">
//               <Form.Label>City</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="city"
//                 value={formData.city}
//                 onChange={(e) =>
//                   setFormData({ ...formData, city: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formAddress" className="mb-3">
//               <Form.Label>Address</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="Address"
//                 value={formData.Address}
//                 onChange={(e) =>
//                   setFormData({ ...formData, Address: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formExperience" className="mb-3">
//               <Form.Label>Experience (Years)</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="experience"
//                 value={formData.experience}
//                 onChange={(e) =>
//                   setFormData({ ...formData, experience: e.target.value })
//                 }
//               />
//             </Form.Group>
//             <Form.Group controlId="formApproveStatus" className="mb-3">
//               <Form.Label>Status</Form.Label>
//               <Form.Select
//                 name="approve_status"
//                 value={formData.approve_status}
//                 onChange={(e) =>
//                   setFormData({ ...formData, approve_status: e.target.value })
//                 }
//               >
//                 <option value="Pending">Pending</option>
//                 <option value="Approved">Approved</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Select>
//             </Form.Group>

//             <Form.Group controlId="formBalance" className="mb-3">
//               <Form.Label>Balance (TK)</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="balance"
//                 value={formData.balance}
//                 onChange={(e) =>
//                   setFormData({ ...formData, balance: e.target.value })
//                 }
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowEditModal(false)}>
//             Close
//           </Button>
//           <Button variant="primary" onClick={handleUpdate}>
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Image Preview Modal */}
//       <Modal
//         show={showImageModal}
//         onHide={() => setShowImageModal(false)}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Image Preview</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-center">
//           <Image src={imageSrc} alt="Preview" fluid />
//         </Modal.Body>
//       </Modal>
//     </Container>
//   );
// };

// export default ServitorDetails;

// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   InputGroup,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Alert,
//   Pagination,
//   Image,
// } from "react-bootstrap";
// import axios from "axios";
// import {
//   FaPencilAlt,
//   FaTrash,
//   FaSearch,
//   FaBolt,
//   FaBroom,
//   FaCogs,
//   FaUserCheck,
//   FaUserClock,
//   FaEye,
// } from "react-icons/fa";
// import "./ServitorDetails.css";
// import { URL } from "../../../config";

// // const API_BASE = "http://localhost:4001";

// const fileUrl = (p) => {
//   if (!p) return "";
//   if (/^https?:\/\//i.test(p)) return p;
//   if (p.startsWith("/uploads/")) return `${URL}${p}`;
//   if (p.startsWith("uploads/")) return `${URL}/${p}`;
//   return `${URL}/uploads/${p}`;
// };

// const isPdf = (u) => /\.pdf(\?|#|$)/i.test(u || "");
// const isImage = (u) => /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(u || "");

// const ServitorDetails = () => {
//   const [servitors, setServitors] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResult, setSearchResult] = useState([]);
//   const [filterType, setFilterType] = useState("All");
//   const [filterStatus, setFilterStatus] = useState("All");
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [imageSrc, setImageSrc] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [editServitor, setEditServitor] = useState(null);
//   const [viewServitor, setViewServitor] = useState(null);
//   const itemsPerPage = 10;

//   const [formData, setFormData] = useState({
//     FirstName: "",
//     LastName: "",
//     email: "",
//     mobile: "",
//     NID: "",
//     dob: "",
//     gender: "",
//     service: "",
//     city: "",
//     Address: "",
//     experience: "",
//     approve_status: "",
//     balance: "",
//     bio: "",

//     studentIdCard: null,
//     resume: null,
//   });

//   useEffect(() => {
//     fetchServitors();
//   }, []);

//   const fetchServitors = async () => {
//     try {
//       const response = await axios.get(`${URL}/allservitors`);
//       setServitors(response.data);
//       setSearchResult(response.data);
//     } catch (error) {
//       console.error("Error fetching servitors:", error);
//       setErrorMessage("Failed to fetch servitors. Please try again later.");
//     }
//   };

//   const handleImageClick = (src) => {
//     setImageSrc(src);
//     setShowImageModal(true);
//   };

//   useEffect(() => {
//     let results = servitors;

//     if (searchTerm) {
//       results = results.filter(
//         (s) =>
//           s.FirstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           s.LastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           s.mobile.toString().includes(searchTerm) ||
//           // s.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           s.service.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     if (filterType !== "All") {
//       results = results.filter((s) => s.service === filterType);
//     }

//     if (filterStatus !== "All") {
//       results = results.filter((s) => s.approve_status === filterStatus);
//     }

//     setSearchResult(results);
//     setCurrentPage(1);
//   }, [servitors, searchTerm, filterType, filterStatus]);

//   const handleEdit = (servitor) => {
//     setEditServitor(servitor);
//     setFormData({
//       FirstName: servitor.FirstName,
//       LastName: servitor.LastName,
//       email: servitor.email,
//       mobile: servitor.mobile,
//       NID: servitor.NID,
//       dob: servitor.dob.split("T")[0],
//       gender: servitor.gender,
//       service: servitor.service,
//       city: servitor.city,
//       Address: servitor.Address,
//       experience: servitor.experience,
//       approve_status: servitor.approve_status,
//       balance: servitor.balance ?? 0,
//       bio: servitor.bio || "",

//       studentIdCard: null,
//       resume: null,
//     });
//     setShowEditModal(true);
//   };

//   const handleView = (servitor) => {
//     setViewServitor(servitor);
//     setShowViewModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this servitor?")) {
//       try {
//         await axios.delete(`${URL}/servitors/${id}`);
//         fetchServitors();
//         setErrorMessage("Servitor deleted successfully.");
//       } catch (error) {
//         console.error("Error deleting servitor:", error);
//         setErrorMessage("Failed to delete servitor. Please try again.");
//       }
//     }
//   };

//   // const handleUpdate = async () => {
//   //   try {
//   //     const updateData = { ...formData };
//   //     await axios.put(
//   //       `http://localhost:4001/servitors/${editServitor.Id}`,
//   //       updateData
//   //     );
//   //     fetchServitors();
//   //     setShowEditModal(false);
//   //     setErrorMessage("Servitor updated successfully.");
//   //   } catch (error) {
//   //     console.error("Error updating servitor:", error);
//   //     setErrorMessage("Failed to update servitor. Please try again.");
//   //   }
//   // };

//   const handleUpdate = async () => {
//     try {
//       const form = new FormData();
//       for (const [key, value] of Object.entries(formData)) {
//         if (value !== null && value !== undefined) {
//           form.append(key, value);
//         }
//       }

//       await axios.put(
//         `${URL}/servitors/${editServitor.Id}`,
//         form,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       fetchServitors();
//       setShowEditModal(false);
//       setErrorMessage("Servitor updated successfully.");
//     } catch (error) {
//       console.error("Error updating servitor:", error);
//       setErrorMessage("Failed to update servitor. Please try again.");
//     }
//   };

//   // Pagination Logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentServitors = searchResult.slice(
//     indexOfFirstItem,
//     indexOfLastItem
//   );
//   const totalPages = Math.ceil(searchResult.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Summary Card Counts
//   const electricianCount = servitors.filter(
//     (s) => s.service === "Electrician"
//   ).length;
//   const plumberCount = servitors.filter((s) => s.service === "Plumber").length;
//   const homeCleaningCount = servitors.filter(
//     (s) => s.service === "Home Cleaning"
//   ).length;
//   const pendingCount = servitors.filter(
//     (s) => s.approve_status === "Pending"
//   ).length;
//   const approvedCount = servitors.filter(
//     (s) => s.approve_status === "Approved"
//   ).length;

//   return (
//     <Container fluid className="adminservitordetails-container">
//       {errorMessage && (
//         <Alert
//           variant={errorMessage.includes("successfully") ? "success" : "danger"}
//           onClose={() => setErrorMessage("")}
//           dismissible
//           className="adminservitordetails-alert"
//         >
//           {errorMessage}
//         </Alert>
//       )}
//       <Card className="adminservitordetails-card">
//         <Card.Body>
//           {/* <Card.Title className="adminservitordetails-title">
//             Servitor Details
//           </Card.Title> */}

//           <Card.Header className="adminservitordetails-header">
//             <h4 className="adminservitordetails-title">Servitor Details</h4>
//           </Card.Header>

//           {/* Summary Cards */}
//           <div className="adminservitordetails-summary-cards">
//             <div className="adminservitordetails-summary-card adminservitordetails-electrician-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">
//                   Total Electricians
//                 </p>
//                 <p className="adminservitordetails-count-value">
//                   {electricianCount}
//                 </p>
//               </div>
//               <FaBolt size={20} style={{ color: "#10b981" }} />
//             </div>
//             <div className="adminservitordetails-summary-card adminservitordetails-plumber-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">
//                   Total Plumbers
//                 </p>
//                 <p className="adminservitordetails-count-value">
//                   {plumberCount}
//                 </p>
//               </div>
//               <FaCogs size={20} style={{ color: "#3b82f6" }} />
//             </div>
//             <div className="adminservitordetails-summary-card adminservitordetails-home-cleaning-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">
//                   Total Home Cleaning
//                 </p>
//                 <p className="adminservitordetails-count-value">
//                   {homeCleaningCount}
//                 </p>
//               </div>
//               <FaBroom size={20} style={{ color: "#22c55e" }} />
//             </div>
//             <div className="adminservitordetails-summary-card adminservitordetails-pending-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">
//                   Total Pending
//                 </p>
//                 <p className="adminservitordetails-count-value">
//                   {pendingCount}
//                 </p>
//               </div>
//               <FaUserClock size={20} style={{ color: "#f59e0b" }} />
//             </div>
//             <div className="adminservitordetails-summary-card adminservitordetails-approved-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">
//                   Total Approved
//                 </p>
//                 <p className="adminservitordetails-count-value">
//                   {approvedCount}
//                 </p>
//               </div>
//               <FaUserCheck size={20} style={{ color: "#10b981" }} />
//             </div>
//           </div>

//           {/* Filters and Search */}
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by name, mobile or service"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="adminservitordetails-search"
//                 />
//                 <InputGroup.Text>
//                   <FaSearch />
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => setFilterStatus(e.target.value)}
//                   className="adminservitordetails-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Pending">Pending</option>
//                   <option value="Approved">Approved</option>
//                   <option value="Blocked">Blocked</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="adminservitordetails-filter-container">
//             {["All", "Electrician", "Plumber", "Home Cleaning"].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="adminservitordetails-filter-btn"
//                 onClick={() => setFilterType(type)}
//               >
//                 {type}
//               </Button>
//             ))}
//           </div>

//           {/* Table with Scrollable Wrapper */}
//           <div className="adminservitordetails-table-wrapper">
//             <Table
//               striped
//               bordered
//               hover
//               responsive
//               className="adminservitordetails-table"
//             >
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Name</th>
//                   {/* <th>Email</th> */}
//                   <th>Mobile</th>
//                   <th>Service</th>
//                   {/* <th>City</th> */}
//                   {/* <th>Experience</th> */}
//                   <th>Balance</th>
//                   <th>Image</th>
//                   <th>NID</th>
//                   <th>DOC</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentServitors.map((servitor, index) => (
//                   <tr key={servitor.Id}>
//                     <td>{index + 1 + indexOfFirstItem}</td>
//                     <td>{`${servitor.FirstName} ${servitor.LastName}`}</td>
//                     {/* <td>{servitor.email}</td> */}
//                     <td>{servitor.mobile}</td>
//                     <td>{servitor.service}</td>
//                     {/* <td>{servitor.city}</td> */}
//                     {/* <td>{servitor.experience} yrs</td> */}
//                     <td>{servitor.balance} Tk</td>
//                     <td>
//                       <Image
//                         src={
//                           servitor.image
//                             ? `${URL}/uploads/${servitor.image}`
//                             : "/default-avatar.png"
//                         }
//                         alt={servitor.FirstName}
//                         rounded
//                         width="40"
//                         height="40"
//                         style={{ cursor: "pointer" }}
//                         onClick={() =>
//                           handleImageClick(
//                             servitor.image
//                               ? `${URL}/uploads/${servitor.image}`
//                               : "/default-avatar.png"
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       {servitor.DOC ? (
//                         <a
//                           href={`${URL}/uploads/${servitor.DOC}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <i
//                             className="bi bi-file-earmark-pdf"
//                             style={{ fontSize: "1.2rem", color: "#ef4444" }}
//                           ></i>
//                         </a>
//                       ) : (
//                         <i
//                           className="bi bi-file-earmark"
//                           style={{ fontSize: "1.2rem", color: "#6b7280" }}
//                         >
//                           N/A
//                         </i>
//                       )}
//                     </td>
//                     <td>
//                       {servitor.tutorProfile?.resume  ? (
//                         <a
//                           href={`${URL}/uploads/${servitor.tutorProfile?.resume }`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <i
//                             className="bi bi-file-earmark-pdf"
//                             style={{ fontSize: "1.2rem", color: "#ef4444" }}
//                           ></i>
//                         </a>
//                       ) : (
//                         <i
//                           className="bi bi-file-earmark"
//                           style={{ fontSize: "1.2rem", color: "#6b7280" }}
//                         >
//                           N/A
//                         </i>
//                       )}
//                     </td>
//                     <td>
//                       <span
//                         className={`adminservitordetails-badge-${servitor.approve_status.toLowerCase()}`}
//                       >
//                         {servitor.approve_status}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="adminservitordetails-action-group">
//                         <Button
//                           variant="outline-info"
//                           size="sm"
//                           className="adminservitordetails-action-btn"
//                           onClick={() => handleView(servitor)}
//                         >
//                           <FaEye size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminservitordetails-action-btn"
//                           onClick={() => handleEdit(servitor)}
//                         >
//                           <FaPencilAlt size={16} />
//                         </Button>
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           className="adminservitordetails-action-btn"
//                           onClick={() => handleDelete(servitor.Id)}
//                         >
//                           <FaTrash size={16} />
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>

//           {/* Pagination */}
//           <Pagination className="adminservitordetails-pagination">
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* View Servitor Modal */}
//       <Modal
//         show={showViewModal}
//         onHide={() => setShowViewModal(false)}
//         centered
//         size="lg"
//         className="adminservitordetails-Viewmodal"
//       >
//         <Modal.Header
//           closeButton
//           className="adminservitordetails-Viewmodal-header"
//         >
//           <div className="adminservitordetails-Viewmodal-header-content">
//             <Modal.Title className="adminservitordetails-Viewmodal-title">
//               Servitor Details
//             </Modal.Title>
//             <p className="adminservitordetails-Viewmodal-subtitle">
//               {viewServitor?.FirstName} {viewServitor?.LastName}
//             </p>
//           </div>
//         </Modal.Header>
//         <Modal.Body className="adminservitordetails-Viewmodal-body">
//           {viewServitor && (
//             <>
//               {/* Profile Section */}
//               <div className="adminservitordetails-Viewmodal-profile">
//                 <div className="adminservitordetails-Viewmodal-avatar">
//                   {viewServitor.FirstName?.charAt(0)}
//                   {viewServitor.LastName?.charAt(0)}
//                 </div>
//                 <div className="adminservitordetails-Viewmodal-profile-info">
//                   <h3 className="adminservitordetails-Viewmodal-name">
//                     {viewServitor.FirstName} {viewServitor.LastName}
//                   </h3>
//                   <div className="adminservitordetails-Viewmodal-badges">
//                     <span
//                       className={`adminservitordetails-Viewmodal-badge ${
//                         viewServitor.approve_status === "Approved"
//                           ? "approved"
//                           : viewServitor.approve_status === "Pending"
//                           ? "pending"
//                           : "blocked"
//                       }`}
//                     >
//                       {viewServitor.approve_status === "Approved"
//                         ? "Approved"
//                         : viewServitor.approve_status}
//                     </span>
//                     <span className="adminservitordetails-Viewmodal-badge experience">
//                       {viewServitor.experience} year Experience
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* Details Grid */}
//               <div className="adminservitordetails-Viewmodal-details-grid">
//                 {/* Personal Information */}
//                 <div className="adminservitordetails-Viewmodal-section">
//                   <h4 className="adminservitordetails-Viewmodal-section-title">
//                     <i
//                       className="bi bi-person"
//                       style={{ marginRight: "8px", color: "#8B5CF6" }}
//                     ></i>
//                     Personal Information
//                   </h4>
//                   <div className="adminservitordetails-Viewmodal-section-content">
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Servitor ID
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.Id}
//                       </span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Gender
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.gender}
//                       </span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Experience
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.experience} year
//                       </span>
//                     </div>

//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         NID
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.NID}
//                       </span>
//                     </div>

//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         City
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.city}
//                       </span>
//                     </div>

//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Area
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.area}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Contact & Finance */}
//                 <div className="adminservitordetails-Viewmodal-section">
//                   <h4 className="adminservitordetails-Viewmodal-section-title">
//                     <i
//                       className="bi bi-geo-alt"
//                       style={{ marginRight: "8px", color: "#8B5CF6" }}
//                     ></i>
//                     Contact & Balance
//                   </h4>
//                   <div className="adminservitordetails-Viewmodal-section-content">
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Balance
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value balance">
//                         {viewServitor.balance || 0} Tk
//                       </span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Phone
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.mobile}
//                       </span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Email
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.email}
//                       </span>
//                     </div>

//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         Join Date
//                       </span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {new Date(viewServitor.created_at).toLocaleDateString(
//                           "en-US",
//                           {
//                             year: "numeric",
//                             month: "long",
//                             day: "numeric",
//                           }
//                         )}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Address Section */}
//               <div className="adminservitordetails-Viewmodal-full-section">
//                 <h4 className="adminservitordetails-Viewmodal-section-title">
//                   <i
//                     className="bi bi-house"
//                     style={{ marginRight: "8px", color: "#8B5CF6" }}
//                   ></i>
//                   Address
//                 </h4>
//                 <div className="adminservitordetails-Viewmodal-address-content">
//                   {viewServitor.Address}
//                 </div>
//               </div>

//               {/* Bio Section */}
//               <div className="adminservitordetails-Viewmodal-full-section">
//                 <h4 className="adminservitordetails-Viewmodal-section-title">
//                   <i
//                     className="bi bi-file-text"
//                     style={{ marginRight: "8px", color: "#8B5CF6" }}
//                   ></i>
//                   Bio
//                 </h4>
//                 <div className="adminservitordetails-Viewmodal-bio-content">
//                   {viewServitor.bio || "N/A"}
//                 </div>
//               </div>

//               {/* Tutor Verification (only for Tutor service) */}
//               {(viewServitor?.service === "Tutor" ||
//                 viewServitor?.service === "Tutor Service" ||
//                 viewServitor?.tutorProfile) && (
//                 <div className="adminservitordetails-Viewmodal-full-section">
//                   <h4 className="adminservitordetails-Viewmodal-section-title">
//                     <i
//                       className="bi bi-mortarboard"
//                       style={{ marginRight: 8, color: "#8B5CF6" }}
//                     ></i>
//                     Tutor Verification
//                   </h4>

//                   <div
//                     className="adminservitordetails-Viewmodal-details-grid"
//                     style={{ marginTop: 8 }}
//                   >
//                     {/* Left: Education details */}
//                     <div className="adminservitordetails-Viewmodal-section">
//                       <div className="adminservitordetails-Viewmodal-section-content">
//                         <div className="adminservitordetails-Viewmodal-detail-item">
//                           <span className="adminservitordetails-Viewmodal-label">
//                             University Type
//                           </span>
//                           <span className="adminservitordetails-Viewmodal-value">
//                             {viewServitor?.tutorProfile?.universityType ||
//                               "N/A"}
//                           </span>
//                         </div>
//                         <div className="adminservitordetails-Viewmodal-detail-item">
//                           <span className="adminservitordetails-Viewmodal-label">
//                             University Name
//                           </span>
//                           <span className="adminservitordetails-Viewmodal-value">
//                             {viewServitor?.tutorProfile?.universityName ||
//                               "N/A"}
//                           </span>
//                         </div>
//                         <div className="adminservitordetails-Viewmodal-detail-item">
//                           <span className="adminservitordetails-Viewmodal-label">
//                             Major
//                           </span>
//                           <span className="adminservitordetails-Viewmodal-value">
//                             {viewServitor?.tutorProfile?.major || "N/A"}
//                           </span>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Right: Student ID preview / link */}
//                     <div className="adminservitordetails-Viewmodal-section">
//                       <div className="adminservitordetails-Viewmodal-section-content">
//                         <div
//                           className="adminservitordetails-Viewmodal-detail-item"
//                           style={{ display: "block" }}
//                         >
//                           <span
//                             className="adminservitordetails-Viewmodal-label"
//                             style={{ display: "block", marginBottom: 8 }}
//                           >
//                             Student ID Card
//                           </span>

//                           {(() => {
//                             const raw =
//                               viewServitor?.tutorProfile?.studentIdCard;
//                             const u = fileUrl(raw);
//                             if (!raw)
//                               return (
//                                 <span className="adminservitordetails-Viewmodal-value">
//                                   N/A
//                                 </span>
//                               );

//                             // if (isImage(u)) {
//                             //   // Click to open your existing Image Preview modal
//                             //   return (
//                             //     <div
//                             //       className="adminservitordetails-studentid-thumb"
//                             //       role="button"
//                             //       title="Click to preview"
//                             //       onClick={() => handleImageClick(u)}
//                             //     >
//                             //       <img src={u} alt="Student ID" />
//                             //     </div>
//                             //   );
//                             // }

//                             if (isImage(u)) {
//                               return (
//                                 <a
//                                   href={u}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                   className="adminservitordetails-studentid-thumb"
//                                   title="Open image in a new tab"
//                                 >
//                                   <img src={u} alt="Student ID" />
//                                 </a>
//                               );
//                             }

//                             if (isPdf(u)) {
//                               // Inline PDF preview
//                               return (
//                                 <div className="adminservitordetails-studentid-pdf">
//                                   <iframe
//                                     src={u}
//                                     title="Student ID PDF"
//                                     className="adminservitordetails-studentid-iframe"
//                                   />
//                                   <a
//                                     href={u}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="adminservitordetails-Viewmodal-value"
//                                     style={{
//                                       display: "inline-block",
//                                       marginTop: 8,
//                                     }}
//                                   >
//                                     Open in new tab
//                                   </a>
//                                 </div>
//                               );
//                             }

//                             // Fallback for unknown file types
//                             return (
//                               <a
//                                 href={u}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="adminservitordetails-Viewmodal-value"
//                               >
//                                 Open Student ID
//                               </a>
//                             );
//                           })()}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer className="adminservitordetails-Viewmodal-footer">
//           <Button
//             variant="warning"
//             className="adminservitordetails-Viewmodal-edit-btn"
//             onClick={() => {
//               setShowViewModal(false);
//               handleEdit(viewServitor);
//             }}
//           >
//             <i className="bi bi-pencil" style={{ marginRight: "6px" }}></i>
//             Edit
//           </Button>
//           <Button
//             variant="secondary"
//             onClick={() => setShowViewModal(false)}
//             className="adminservitordetails-Viewmodal-close-btn"
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Servitor Modal */}
//       <Modal
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         centered
//         className="adminservitordetails-modal"
//       >
//         <Modal.Header closeButton className="adminservitordetails-modal-header">
//           <Modal.Title>Edit Servitor</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminservitordetails-modal-body">
//           <Form>
//             <Form.Group controlId="formFirstName" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 First Name
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="FirstName"
//                 value={formData.FirstName}
//                 onChange={(e) =>
//                   setFormData({ ...formData, FirstName: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formLastName" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Last Name
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="LastName"
//                 value={formData.LastName}
//                 onChange={(e) =>
//                   setFormData({ ...formData, LastName: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formEmail" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Email
//               </Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={(e) =>
//                   setFormData({ ...formData, email: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formMobile" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Mobile
//               </Form.Label>
//               <Form.Control
//                 type="number"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={(e) =>
//                   setFormData({ ...formData, mobile: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formNID" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 NID
//               </Form.Label>
//               <Form.Control
//                 type="number"
//                 name="NID"
//                 value={formData.NID}
//                 onChange={(e) =>
//                   setFormData({ ...formData, NID: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formDOB" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Date of Birth
//               </Form.Label>
//               <Form.Control
//                 type="date"
//                 name="dob"
//                 value={formData.dob}
//                 onChange={(e) =>
//                   setFormData({ ...formData, dob: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formGender" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Gender
//               </Form.Label>
//               <Form.Select
//                 name="gender"
//                 value={formData.gender}
//                 onChange={(e) =>
//                   setFormData({ ...formData, gender: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               >
//                 <option value="">Select Gender</option>
//                 <option value="Male">Male</option>
//                 <option value="Female">Female</option>
//                 <option value="Other">Other</option>
//               </Form.Select>
//             </Form.Group>
//             <Form.Group controlId="formService" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Service
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="service"
//                 value={formData.service}
//                 onChange={(e) =>
//                   setFormData({ ...formData, service: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formCity" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 City
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="city"
//                 value={formData.city}
//                 onChange={(e) =>
//                   setFormData({ ...formData, city: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formAddress" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Address
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="Address"
//                 value={formData.Address}
//                 onChange={(e) =>
//                   setFormData({ ...formData, Address: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formExperience" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Experience (Years)
//               </Form.Label>
//               <Form.Control
//                 type="number"
//                 name="experience"
//                 value={formData.experience}
//                 onChange={(e) =>
//                   setFormData({ ...formData, experience: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>
            
//             <Form.Group controlId="formBio" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Bio
//               </Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={4}
//                 name="bio"
//                 value={formData.bio}
//                 onChange={(e) =>
//                   setFormData({ ...formData, bio: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formApproveStatus" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Status
//               </Form.Label>
//               <Form.Select
//                 name="approve_status"
//                 value={formData.approve_status}
//                 onChange={(e) =>
//                   setFormData({ ...formData, approve_status: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               >
//                 <option value="Pending">Pending</option>
//                 <option value="Approved">Approved</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Select>
//             </Form.Group>
//             {/* <Form.Group controlId="formBalance" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 Balance (TK)
//               </Form.Label>
//               <Form.Control
//                 type="number"
//                 name="balance"
//                 value={formData.balance}
//                 onChange={(e) =>
//                   setFormData({ ...formData, balance: e.target.value })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group> */}
            

//             <Form.Group controlId="formDOC" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">
//                 NID Document
//               </Form.Label>
//               <Form.Control
//                 type="file"
//                 name="certificate"
//                 accept=".pdf,.jpg,.jpeg,.png"
//                 onChange={(e) =>
//                   setFormData({ ...formData, certificate: e.target.files[0] })
//                 }
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             {(formData.service === "Tutor" || formData.service === "Tutor Service") && (
//               <>
//                 <Form.Group controlId="formStudentIdCard" className="mb-3">
//                   <Form.Label className="adminservitordetails-form-label">
//                     Student ID Card
//                   </Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="studentIdCard"
//                     accept=".pdf,.jpg,.jpeg,.png"
//                     onChange={(e) =>
//                       setFormData({ ...formData, studentIdCard: e.target.files[0] })
//                     }
//                     className="adminservitordetails-form-control"
//                   />
//                 </Form.Group>

//                 <Form.Group controlId="formResume" className="mb-3">
//                   <Form.Label className="adminservitordetails-form-label">
//                     Resume
//                   </Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="resume"
//                     accept=".pdf,.jpg,.jpeg,.png"
//                     onChange={(e) =>
//                       setFormData({ ...formData, resume: e.target.files[0] })
//                     }
//                     className="adminservitordetails-form-control"
//                   />
//                 </Form.Group>
//               </>
//             )}

//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminservitordetails-modal-footer">
//           <Button
//             variant="secondary"
//             onClick={() => setShowEditModal(false)}
//             className="adminservitordetails-footer-btn adminservitordetails-footer-btn-close"
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleUpdate}
//             className="adminservitordetails-footer-btn adminservitordetails-footer-btn-save"
//           >
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Image Preview Modal */}
//       <Modal
//         show={showImageModal}
//         onHide={() => setShowImageModal(false)}
//         centered
//         size="lg"
//         className="adminservitordetails-modal"
//       >
//         <Modal.Header closeButton className="adminservitordetails-modal-header">
//           <Modal.Title>Image Preview</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminservitordetails-modal-body text-center">
//           <Image src={imageSrc} alt="Preview" fluid />
//         </Modal.Body>
//       </Modal>
//     </Container>
//   );
// };

// export default ServitorDetails;







// Updated with paginations form backend (19-Oct-2025) ***** //
// import React, { useState, useEffect, useMemo } from "react";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   InputGroup,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Alert,
//   Pagination,
//   Image,
//   Spinner,
// } from "react-bootstrap";
// import axios from "axios";
// import {
//   FaPencilAlt,
//   FaTrash,
//   FaSearch,
//   FaBolt,
//   FaBroom,
//   FaCogs,
//   FaUserCheck,
//   FaUserClock,
//   FaEye,
//   FaFire,
//   FaSnowflake,
//   FaFilter as FaFilterIcon,
//   FaUserGraduate,
// } from "react-icons/fa";
// import "./ServitorDetails.css";
// import { URL } from "../../../config";

// // Build a safe file URL against /uploads
// const fileUrl = (p) => {
//   if (!p) return "";
//   if (/^https?:\/\//i.test(p)) return p;
//   const clean = p.startsWith("/") ? p : `/${p}`;
//   return `${URL}${clean.startsWith("/uploads/") ? clean : `/uploads${clean}`}`;
// };

// const isPdf = (u) => /\.pdf(\?|#|$)/i.test(u || "");
// const isImage = (u) => /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(u || "");

// const ServitorDetails = () => {
//   // table data
//   const [servitors, setServitors] = useState([]);
//   // meta
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   // filters & search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("All"); // service
//   const [filterStatus, setFilterStatus] = useState("All");

//   // pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [totalPages, setTotalPages] = useState(1);
//   const [total, setTotal] = useState(0);

//   // summary cards (from backend)
//   const [summary, setSummary] = useState({
//     total: 0,
//     byService: {
//       Electrician: 0,
//       Plumber: 0,
//       HomeCleaning: 0,
//       GasChula: 0,
//       ACService: 0,
//       Filter: 0,
//       TutorService: 0,
//     },
//     byStatus: { Approved: 0, Pending: 0, Blocked: 0 },
//   });

//   // view / edit modals
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [imageSrc, setImageSrc] = useState("");
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [editServitor, setEditServitor] = useState(null);
//   const [viewServitor, setViewServitor] = useState(null);

//   const [creditAmount, setCreditAmount] = useState('');
//   const [creditNote, setCreditNote] = useState('');
//   const [creditLoading, setCreditLoading] = useState(false);


//   const [formData, setFormData] = useState({
//     FirstName: "",
//     LastName: "",
//     email: "",
//     mobile: "",
//     NID: "",
//     dob: "",
//     gender: "",
//     service: "",
//     city: "",
//     Address: "",
//     experience: "",
//     approve_status: "",
//     balance: "",
//     bio: "",
//     image: null,
//     certificate: null, // NID document
//     studentIdCard: null,
//     resume: null,
//   });


//   const addQuick = (v) => setCreditAmount((prev) => String((Number(prev) || 0) + v));

//   const creditBalance = async () => {
//   const amt = Number(creditAmount);
//   if (!Number.isFinite(amt) || amt <= 0) {
//     setErrorMessage('Enter a valid positive amount.');
//     return;
//   }
//   if (!viewServitor) return;
//   try {
//     setCreditLoading(true);
//     const resp = await axios.post(`${URL}/servitors/${viewServitor.Id}/credit`, {
//       amount: amt,
//       note: creditNote,
//     });
//     // update local + list
//     const newBal = resp?.data?.newBalance ?? (viewServitor.balance + amt);
//     setViewServitor({ ...viewServitor, balance: newBal });
//     setErrorMessage('Balance credited successfully.');
//     setCreditAmount('');
//     setCreditNote('');
//     // refresh table & summary
//     fetchServitors();
//   } catch (e) {
//     const msg = e?.response?.data?.error || 'Failed to credit balance.';
//     setErrorMessage(msg);
//   } finally {
//     setCreditLoading(false);
//   }
// };

//   // -------- fetch helpers (server-side pagination) --------
//   const fetchServitors = async () => {
//     setLoading(true);
//     try {
//       const params = {
//         page: currentPage,
//         limit: itemsPerPage,
//         sortBy: "Id",
//         sortOrder: "DESC",
//       };
//       const st = searchTerm.trim();
//       if (st) params.search = st;
//       if (filterType !== "All") params.service = filterType;
//       if (filterStatus !== "All") params.status = filterStatus;

//       const resp = await axios.get(`${URL}/allservitors`, { params });
//       const payload = resp.data || {};
//       setServitors(payload.data || []);
//       setTotalPages(payload.totalPages || 1);
//       setTotal(payload.total || 0);
//       if (payload.summary) setSummary(payload.summary);
//       setErrorMessage("");
//     } catch (err) {
//       console.error("Error fetching servitors:", err);
//       const msg =
//         err?.response?.data?.error ||
//         err?.response?.data?.message ||
//         "Failed to fetch servitors.";
//       setServitors([]);
//       setTotal(0);
//       setTotalPages(1);
//       setErrorMessage(msg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // initial + when page / filters change
//   useEffect(() => {
//     fetchServitors();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage, filterType, filterStatus]);

//   // debounce search
//   useEffect(() => {
//     const t = setTimeout(() => {
//       setCurrentPage(1);
//       fetchServitors();
//     }, 400);
//     return () => clearTimeout(t);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [searchTerm]);


//   const hasAcceptedTerms =
//   !!viewServitor &&
//   (
//     viewServitor.termsAccepted === true ||
//     viewServitor.termsAccepted === 1 ||
//     viewServitor.termsAccepted === "1" ||
//     viewServitor.termsAccepted === "true"
//   );


//   // ---------- UI handlers ----------
//   const handleImageClick = (src) => {
//     setImageSrc(src);
//     setShowImageModal(true);
//   };

//   const handleEdit = (servitor) => {
//     setEditServitor(servitor);
//     setFormData({
//       FirstName: servitor.FirstName || "",
//       LastName: servitor.LastName || "",
//       email: servitor.email || "",
//       mobile: servitor.mobile || "",
//       NID: servitor.NID || "",
//       dob: servitor.dob ? String(servitor.dob).split("T")[0] : "",
//       gender: servitor.gender || "",
//       service: servitor.service || "",
//       city: servitor.city || "",
//       Address: servitor.Address || "",
//       experience: servitor.experience ?? "",
//       approve_status: servitor.approve_status || "Pending",
//       balance: servitor.balance ?? 0,
//       bio: servitor.bio || "",
//       certificate: null,
//       studentIdCard: null,
//       resume: null,
//     });
//     setShowEditModal(true);
//   };

//   const handleView = (servitor) => {
//     setViewServitor(servitor);
//     setShowViewModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this servitor?")) return;
//     try {
//       await axios.delete(`${URL}/servitors/${id}`);
//       setErrorMessage("Servitor deleted successfully.");
//       // Refresh current page (go back a page if last item removed)
//       const isLastItemOnPage = servitors.length === 1 && currentPage > 1;
//       if (isLastItemOnPage) setCurrentPage((p) => p - 1);
//       else fetchServitors();
//     } catch (error) {
//       console.error("Error deleting servitor:", error);
//       setErrorMessage("Failed to delete servitor. Please try again.");
//     }
//   };

//   const handleUpdate = async () => {
//     if (!editServitor) return;
//     try {
//       const form = new FormData();
//       Object.entries(formData).forEach(([k, v]) => {
//         if (v !== undefined && v !== null && v !== "") form.append(k, v);
//       });

//       await axios.put(`${URL}/servitors/${editServitor.Id}`, form, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       setShowEditModal(false);
//       setErrorMessage("Servitor updated successfully.");
//       fetchServitors();
//     } catch (error) {
//       console.error("Error updating servitor:", error);
//       setErrorMessage("Failed to update servitor. Please try again.");
//     }
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber < 1 || pageNumber > totalPages) return;
//     setCurrentPage(pageNumber);
//   };

//   // summary cards (from server totals)
//   const electricianCount  = summary.byService?.Electrician || 0;
//   const plumberCount      = summary.byService?.Plumber || 0;
//   const homeCleaningCount = summary.byService?.HomeCleaning || 0;
//   const gasChulaCount     = summary.byService?.GasChula || 0;
//   const acServiceCount    = summary.byService?.ACService || 0;
//   const filterCount       = summary.byService?.Filter || 0;
//   const tutorServiceCount = summary.byService?.TutorService || 0;

//   const pendingCount  = summary.byStatus?.Pending || 0;
//   const approvedCount = summary.byStatus?.Approved || 0;

//   // page numbers to render (compact)
//   const pageItems = useMemo(() => {
//     const maxButtons = 7;
//     const pages = [];
//     if (totalPages <= maxButtons) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//       return pages;
//     }
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, currentPage - siblings);
//     let end = Math.min(totalPages - 1, currentPage + siblings);
//     if (currentPage <= siblings + 2) end = Math.min(totalPages - 1, maxButtons - 1);
//     if (currentPage >= totalPages - (siblings + 1))
//       start = Math.max(2, totalPages - (maxButtons - 2));

//     pages.push(1);
//     if (start > 2) pages.push("…");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < totalPages - 1) pages.push("…");
//     pages.push(totalPages);
//     return pages;
//   }, [currentPage, totalPages]);

//   return (
//     <Container fluid className="adminservitordetails-container">
//       {errorMessage && (
//         <Alert
//           variant={errorMessage.includes("successfully") ? "success" : "danger"}
//           onClose={() => setErrorMessage("")}
//           dismissible
//           className="adminservitordetails-alert"
//         >
//           {errorMessage}
//         </Alert>
//       )}

//       <Card className="adminservitordetails-card">
//         <Card.Body>
//           <Card.Header className="adminservitordetails-header">
//             <h4 className="adminservitordetails-title">Servitor Details</h4>
//           </Card.Header>

//           {/* Summary Cards */}
//           {/* <div className="adminservitordetails-summary-cards">
//             <div className="adminservitordetails-summary-card adminservitordetails-electrician-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Electricians</p>
//                 <p className="adminservitordetails-count-value">{electricianCount}</p>
//               </div>
//               <FaBolt size={20} style={{ color: "#10b981" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-plumber-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Plumbers</p>
//                 <p className="adminservitordetails-count-value">{plumberCount}</p>
//               </div>
//               <FaCogs size={20} style={{ color: "#3b82f6" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-home-cleaning-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Home Cleaning</p>
//                 <p className="adminservitordetails-count-value">{homeCleaningCount}</p>
//               </div>
//               <FaBroom size={20} style={{ color: "#22c55e" }} />
//             </div>

//             <div className="adminservitordetails-summary-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Gas Chula</p>
//                 <p className="adminservitordetails-count-value">{gasChulaCount}</p>
//               </div>
//               <FaFire size={20} style={{ color: "#ef4444" }} />
//             </div>

//             <div className="adminservitordetails-summary-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total AC Service</p>
//                 <p className="adminservitordetails-count-value">{acServiceCount}</p>
//               </div>
//               <FaSnowflake size={20} style={{ color: "#60a5fa" }} />
//             </div>

//             <div className="adminservitordetails-summary-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Filter</p>
//                 <p className="adminservitordetails-count-value">{filterCount}</p>
//               </div>
//               <FaFilterIcon size={20} style={{ color: "#8b5cf6" }} />
//             </div>

//             <div className="adminservitordetails-summary-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Tutor Service</p>
//                 <p className="adminservitordetails-count-value">{tutorServiceCount}</p>
//               </div>
//               <FaUserGraduate size={20} style={{ color: "#2563eb" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-pending-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Pending</p>
//                 <p className="adminservitordetails-count-value">{pendingCount}</p>
//               </div>
//               <FaUserClock size={20} style={{ color: "#f59e0b" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-approved-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Approved</p>
//                 <p className="adminservitordetails-count-value">{approvedCount}</p>
//               </div>
//               <FaUserCheck size={20} style={{ color: "#10b981" }} />
//             </div>
//           </div> */}

//           {/* Summary Cards */}
//           <div className="adminservitordetails-summary-cards">
//             <div className="adminservitordetails-summary-card adminservitordetails-electrician-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Electricians</p>
//                 <p className="adminservitordetails-count-value">{electricianCount}</p>
//               </div>
//               <FaBolt size={20} style={{ color: "#10b981" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-plumber-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Plumbers</p>
//                 <p className="adminservitordetails-count-value">{plumberCount}</p>
//               </div>
//               <FaCogs size={20} style={{ color: "#3b82f6" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-home-cleaning-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Home Cleaning</p>
//                 <p className="adminservitordetails-count-value">{homeCleaningCount}</p>
//               </div>
//               <FaBroom size={20} style={{ color: "#22c55e" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-gaschula-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Gas Chula</p>
//                 <p className="adminservitordetails-count-value">{gasChulaCount}</p>
//               </div>
//               <FaFire size={20} style={{ color: "#ef4444" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-acservice-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total AC Service</p>
//                 <p className="adminservitordetails-count-value">{acServiceCount}</p>
//               </div>
//               <FaSnowflake size={20} style={{ color: "#60a5fa" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-filter-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Filter</p>
//                 <p className="adminservitordetails-count-value">{filterCount}</p>
//               </div>
//               <FaFilterIcon size={20} style={{ color: "#8b5cf6" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-tutor-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Tutor Service</p>
//                 <p className="adminservitordetails-count-value">{tutorServiceCount}</p>
//               </div>
//               <FaUserGraduate size={20} style={{ color: "#2563eb" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-pending-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Pending</p>
//                 <p className="adminservitordetails-count-value">{pendingCount}</p>
//               </div>
//               <FaUserClock size={20} style={{ color: "#f59e0b" }} />
//             </div>

//             <div className="adminservitordetails-summary-card adminservitordetails-approved-card">
//               <div>
//                 <p className="adminservitordetails-detail-text">Total Approved</p>
//                 <p className="adminservitordetails-count-value">{approvedCount}</p>
//               </div>
//               <FaUserCheck size={20} style={{ color: "#10b981" }} />
//             </div>
//           </div>


//           {/* Filters and Search */}
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by name, mobile, service, city or area"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="adminservitordetails-search"
//                 />
//                 <InputGroup.Text>
//                   <FaSearch />
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => {
//                     setFilterStatus(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   className="adminservitordetails-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Pending">Pending</option>
//                   <option value="Approved">Approved</option>
//                   <option value="Blocked">Blocked</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="adminservitordetails-filter-container">
//             {[
//               "All",
//               "Electrician",
//               "Plumber",
//               "Home Cleaning",
//               "Gas Chula",
//               "AC Service",
//               "Filter",
//               "Tutor Service",
//             ].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="adminservitordetails-filter-btn"
//                 onClick={() => {
//                   setFilterType(type);
//                   setCurrentPage(1);
//                 }}
//               >
//                 {type}
//               </Button>
//             ))}
//           </div>

//           {/* Table */}
//           <div className="adminservitordetails-table-wrapper">
//             <Table striped bordered hover responsive className="adminservitordetails-table">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Name</th>
//                   <th>Mobile</th>
//                   <th>Service</th>
//                   <th>Balance</th>
//                   <th>Image</th>
//                   <th>NID</th>
//                   <th>DOC</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={10} style={{ textAlign: "center" }}>
//                       <Spinner animation="border" />
//                     </td>
//                   </tr>
//                 ) : servitors.length === 0 ? (
//                   <tr>
//                     <td colSpan={10} style={{ textAlign: "center" }}>
//                       No servitors found.
//                     </td>
//                   </tr>
//                 ) : (
//                   servitors.map((servitor, index) => (
//                     <tr key={servitor.Id}>
//                       <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
//                       <td>{`${servitor.FirstName} ${servitor.LastName}`}</td>
//                       <td>{servitor.mobile}</td>
//                       <td>{servitor.service}</td>
//                       <td>{servitor.balance ?? 0} Tk</td>
//                       <td>
//                         <Image
//                           src={
//                             servitor.image
//                               ? fileUrl(servitor.image)
//                               : "/default-avatar.png"
//                           }
//                           alt={servitor.FirstName}
//                           rounded
//                           width="40"
//                           height="40"
//                           style={{ cursor: "pointer", objectFit: "cover" }}
//                           onClick={() =>
//                             handleImageClick(
//                               servitor.image
//                                 ? fileUrl(servitor.image)
//                                 : "/default-avatar.png"
//                             )
//                           }
//                         />
//                       </td>
//                       <td>
//                         {servitor.DOC ? (
//                           <a
//                             href={fileUrl(servitor.DOC)}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             <i
//                               className="bi bi-file-earmark-pdf"
//                               style={{ fontSize: "1.2rem", color: "#ef4444" }}
//                             ></i>
//                           </a>
//                         ) : (
//                           <i
//                             className="bi bi-file-earmark"
//                             style={{ fontSize: "1.2rem", color: "#6b7280" }}
//                           >
//                             N/A
//                           </i>
//                         )}
//                       </td>
//                       <td>
//                         {servitor.tutorProfile?.resume ? (
//                           <a
//                             href={fileUrl(servitor.tutorProfile?.resume)}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             <i
//                               className="bi bi-file-earmark-pdf"
//                               style={{ fontSize: "1.2rem", color: "#ef4444" }}
//                             ></i>
//                           </a>
//                         ) : (
//                           <i
//                             className="bi bi-file-earmark"
//                             style={{ fontSize: "1.2rem", color: "#6b7280" }}
//                           >
//                             N/A
//                           </i>
//                         )}
//                       </td>
//                       <td>
//                         <span
//                           className={`adminservitordetails-badge-${String(
//                             servitor.approve_status || ""
//                           ).toLowerCase()}`}
//                         >
//                           {servitor.approve_status}
//                         </span>
//                       </td>
//                       <td>
//                         <div className="adminservitordetails-action-group">
//                           <Button
//                             variant="outline-info"
//                             size="sm"
//                             className="adminservitordetails-action-btn"
//                             onClick={() => handleView(servitor)}
//                           >
//                             <FaEye size={16} />
//                           </Button>
//                           <Button
//                             variant="outline-primary"
//                             size="sm"
//                             className="adminservitordetails-action-btn"
//                             onClick={() => handleEdit(servitor)}
//                           >
//                             <FaPencilAlt size={16} />
//                           </Button>
//                           <Button
//                             variant="outline-danger"
//                             size="sm"
//                             className="adminservitordetails-action-btn"
//                             onClick={() => handleDelete(servitor.Id)}
//                           >
//                             <FaTrash size={16} />
//                           </Button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </Table>
//           </div>

//           {/* Pagination */}
//           <Pagination className="adminservitordetails-pagination">
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1 || loading}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1 || loading}
//             />

//             {pageItems.map((p, idx) =>
//               p === "…" ? (
//                 <Pagination.Ellipsis key={`e-${idx}`} disabled />
//               ) : (
//                 <Pagination.Item
//                   key={p}
//                   active={p === currentPage}
//                   onClick={() => handlePageChange(p)}
//                   disabled={loading}
//                 >
//                   {p}
//                 </Pagination.Item>
//               )
//             )}

//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages || loading}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages || loading}
//             />
//           </Pagination>

//           <div className="adminservitordetails-total-hint">
//             Showing page {currentPage} of {totalPages} — {total} total
//           </div>
//         </Card.Body>
//       </Card>

//       {/* View Servitor Modal */}
//       <Modal
//         show={showViewModal}
//         onHide={() => setShowViewModal(false)}
//         centered
//         size="lg"
//         className="adminservitordetails-Viewmodal"
//       >
//         <Modal.Header closeButton className="adminservitordetails-Viewmodal-header">
//           <div className="adminservitordetails-Viewmodal-header-content">
//             <Modal.Title className="adminservitordetails-Viewmodal-title">
//               Servitor Details
//             </Modal.Title>
//             <p className="adminservitordetails-Viewmodal-subtitle">
//               {viewServitor?.FirstName} {viewServitor?.LastName}
//             </p>
//           </div>
//         </Modal.Header>
//         <Modal.Body className="adminservitordetails-Viewmodal-body">
//           {viewServitor && (
//             <>
//               <div className="adminservitordetails-Viewmodal-profile">
//                 <div className="adminservitordetails-Viewmodal-avatar">
//                   {viewServitor.FirstName?.charAt(0)}
//                   {viewServitor.LastName?.charAt(0)}
//                 </div>
//                 <div className="adminservitordetails-Viewmodal-profile-info">
//                   <h3 className="adminservitordetails-Viewmodal-name">
//                     {viewServitor.FirstName} {viewServitor.LastName}
//                   </h3>
//                   <div className="adminservitordetails-Viewmodal-badges">
//                     <span
//                       className={`adminservitordetails-Viewmodal-badge ${
//                         viewServitor.approve_status === "Approved"
//                           ? "approved"
//                           : viewServitor.approve_status === "Pending"
//                           ? "pending"
//                           : "blocked"
//                       }`}
//                     >
//                       {viewServitor.approve_status}
//                     </span>
//                     <span className="adminservitordetails-Viewmodal-badge experience">
//                       {viewServitor.experience} year Experience
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div className="adminservitordetails-Viewmodal-details-grid">
//                 <div className="adminservitordetails-Viewmodal-section">
//                   <h4 className="adminservitordetails-Viewmodal-section-title">
//                     <i className="bi bi-person" style={{ marginRight: 8, color: "#8B5CF6" }}></i>
//                     Personal Information
//                   </h4>
//                   <div className="adminservitordetails-Viewmodal-section-content">
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Servitor ID</span>
//                       <span className="adminservitordetails-Viewmodal-value">{viewServitor.Id}</span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Gender</span>
//                       <span className="adminservitordetails-Viewmodal-value">{viewServitor.gender}</span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Experience</span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {viewServitor.experience} year
//                       </span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">NID</span>
//                       <span className="adminservitordetails-Viewmodal-value">{viewServitor.NID}</span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">City</span>
//                       <span className="adminservitordetails-Viewmodal-value">{viewServitor.city}</span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Area</span>
//                       <span className="adminservitordetails-Viewmodal-value">{viewServitor.area}</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="adminservitordetails-Viewmodal-section">
//                   <h4 className="adminservitordetails-Viewmodal-section-title">
//                     <i className="bi bi-geo-alt" style={{ marginRight: 8, color: "#8B5CF6" }}></i>
//                     Contact & Balance
//                   </h4>
//                   <div className="adminservitordetails-Viewmodal-section-content">
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Balance</span>
//                       <span className="adminservitordetails-Viewmodal-value balance">
//                         {viewServitor.balance || 0} Tk
//                       </span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Phone</span>
//                       <span className="adminservitordetails-Viewmodal-value">{viewServitor.mobile}</span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Email</span>
//                       <span className="adminservitordetails-Viewmodal-value">{viewServitor.email}</span>
//                     </div>
//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">Join Date</span>
//                       <span className="adminservitordetails-Viewmodal-value">
//                         {new Date(viewServitor.created_at).toLocaleDateString("en-US", {
//                           year: "numeric",
//                           month: "long",
//                           day: "numeric",
//                         })}
//                       </span>
//                     </div>

//                     <div className="adminservitordetails-Viewmodal-detail-item">
//                       <span className="adminservitordetails-Viewmodal-label">
//                         HelpNao Servitor Terms
//                       </span>
//                       <span
//                         className={
//                           `adminservitordetails-Viewmodal-value ` +
//                           (hasAcceptedTerms
//                             ? `adminservitordetails-terms-accepted`
//                             : `adminservitordetails-terms-notaccepted`)
//                         }
//                       >
//                         {hasAcceptedTerms ? "Accepted" : "N/A"}
//                       </span>
//                     </div>

//                     {Number(viewServitor?.pin_fail_count || 0) > 0 && (
//                         <div className="adminservitordetails-Viewmodal-detail-item">
//                           <span className="adminservitordetails-Viewmodal-label">
//                             Wrong PIN Attempts
//                           </span>
//                           <span className="adminservitordetails-Viewmodal-value pin-fails">
//                             <span className="pin-fails-dot" aria-hidden="true" />
//                             {Number(viewServitor.pin_fail_count)} time
//                           </span>
//                         </div>
//                       )}

//                   </div>
//                 </div>
//               </div>

//               <div className="adminservitordetails-Viewmodal-full-section">
//                 <h4 className="adminservitordetails-Viewmodal-section-title">
//                   <i className="bi bi-house" style={{ marginRight: 8, color: "#8B5CF6" }}></i>
//                   Address
//                 </h4>
//                 <div className="adminservitordetails-Viewmodal-address-content">
//                   {viewServitor.Address}
//                 </div>
//               </div>

//               <div className="adminservitordetails-Viewmodal-full-section">
//                 <h4 className="adminservitordetails-Viewmodal-section-title">
//                   <i className="bi bi-file-text" style={{ marginRight: 8, color: "#8B5CF6" }}></i>
//                   Bio
//                 </h4>
//                 <div className="adminservitordetails-Viewmodal-bio-content">
//                   {viewServitor.bio || "N/A"}
//                 </div>
//               </div>


//               <div className="adminservitordetails-Viewmodal-detail-item" style={{ display: 'block', marginTop: 12 }}>
//                 <span className="adminservitordetails-Viewmodal-label" style={{ display: 'block', marginBottom: 6 }}>
//                   Admin Credit (Increase Only)
//                 </span>

//                 <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
//                   <Form.Control
//                     type="number"
//                     min="1"
//                     step="1"
//                     placeholder="Amount"
//                     value={creditAmount}
//                     onChange={(e) => setCreditAmount(e.target.value)}
//                     style={{ width: 140 }}
//                   />

//                   <div style={{ display: 'flex', gap: 6 }}>
//                     {[50, 100, 200, 500].map(v => (
//                       <Button key={v} size="sm" variant="outline-success" onClick={() => addQuick(v)}>+{v}</Button>
//                     ))}
//                   </div>

//                   <Button
//                     variant="success"
//                     size="sm"
//                     disabled={creditLoading}
//                     onClick={creditBalance}
//                     title="Add to Servitor balance and record as bonus transaction"
//                   >
//                     {creditLoading ? <Spinner size="sm" animation="border" /> : 'Add Balance'}
//                   </Button>
//                 </div>

//                 <Form.Control
//                   as="textarea"
//                   rows={2}
//                   placeholder="Optional note (e.g., emergency support, dispute resolution)"
//                   value={creditNote}
//                   onChange={(e) => setCreditNote(e.target.value)}
//                   style={{ marginTop: 8 }}
//                 />
//               </div>


//               {(viewServitor?.service === "Tutor Service" ||
//                 viewServitor?.service === "Tutor" ||
//                 viewServitor?.tutorProfile) && (
//                 <div className="adminservitordetails-Viewmodal-full-section">
//                   <h4 className="adminservitordetails-Viewmodal-section-title">
//                     <i className="bi bi-mortarboard" style={{ marginRight: 8, color: "#8B5CF6" }}></i>
//                     Tutor Verification
//                   </h4>

//                   <div className="adminservitordetails-Viewmodal-details-grid" style={{ marginTop: 8 }}>
//                     <div className="adminservitordetails-Viewmodal-section">
//                       <div className="adminservitordetails-Viewmodal-section-content">
//                         <div className="adminservitordetails-Viewmodal-detail-item">
//                           <span className="adminservitordetails-Viewmodal-label">University Type</span>
//                           <span className="adminservitordetails-Viewmodal-value">
//                             {viewServitor?.tutorProfile?.universityType || "N/A"}
//                           </span>
//                         </div>
//                         <div className="adminservitordetails-Viewmodal-detail-item">
//                           <span className="adminservitordetails-Viewmodal-label">University Name</span>
//                           <span className="adminservitordetails-Viewmodal-value">
//                             {viewServitor?.tutorProfile?.universityName || "N/A"}
//                           </span>
//                         </div>
//                         <div className="adminservitordetails-Viewmodal-detail-item">
//                           <span className="adminservitordetails-Viewmodal-label">Major</span>
//                           <span className="adminservitordetails-Viewmodal-value">
//                             {viewServitor?.tutorProfile?.major || "N/A"}
//                           </span>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="adminservitordetails-Viewmodal-section">
//                       <div className="adminservitordetails-Viewmodal-section-content">
//                         <div className="adminservitordetails-Viewmodal-detail-item" style={{ display: "block" }}>
//                           <span className="adminservitordetails-Viewmodal-label" style={{ display: "block", marginBottom: 8 }}>
//                             Student ID Card
//                           </span>

//                           {(() => {
//                             const raw = viewServitor?.tutorProfile?.studentIdCard;
//                             const u = fileUrl(raw);
//                             if (!raw)
//                               return <span className="adminservitordetails-Viewmodal-value">N/A</span>;

//                             if (isImage(u)) {
//                               return (
//                                 <a
//                                   href={u}
//                                   target="_blank"
//                                   rel="noopener noreferrer"
//                                   className="adminservitordetails-studentid-thumb"
//                                   title="Open image in a new tab"
//                                 >
//                                   <img src={u} alt="Student ID" />
//                                 </a>
//                               );
//                             }

//                             if (isPdf(u)) {
//                               return (
//                                 <div className="adminservitordetails-studentid-pdf">
//                                   <iframe src={u} title="Student ID PDF" className="adminservitordetails-studentid-iframe" />
//                                   <a
//                                     href={u}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="adminservitordetails-Viewmodal-value"
//                                     style={{ display: "inline-block", marginTop: 8 }}
//                                   >
//                                     Open in new tab
//                                   </a>
//                                 </div>
//                               );
//                             }

//                             return (
//                               <a href={u} target="_blank" rel="noopener noreferrer" className="adminservitordetails-Viewmodal-value">
//                                 Open Student ID
//                               </a>
//                             );
//                           })()}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer className="adminservitordetails-Viewmodal-footer">
//           <Button
//             variant="warning"
//             className="adminservitordetails-Viewmodal-edit-btn"
//             onClick={() => {
//               setShowViewModal(false);
//               if (viewServitor) handleEdit(viewServitor);
//             }}
//           >
//             <i className="bi bi-pencil" style={{ marginRight: 6 }}></i>
//             Edit
//           </Button>
//           <Button
//             variant="secondary"
//             onClick={() => setShowViewModal(false)}
//             className="adminservitordetails-Viewmodal-close-btn"
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Servitor Modal */}
//       <Modal
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         centered
//         className="adminservitordetails-modal"
//       >
//         <Modal.Header closeButton className="adminservitordetails-modal-header">
//           <Modal.Title>Edit Servitor</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminservitordetails-modal-body">
//           <Form>
//             <Form.Group controlId="formFirstName" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">First Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="FirstName"
//                 value={formData.FirstName}
//                 onChange={(e) => setFormData({ ...formData, FirstName: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formLastName" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Last Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="LastName"
//                 value={formData.LastName}
//                 onChange={(e) => setFormData({ ...formData, LastName: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formEmail" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formMobile" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Mobile</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formNID" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">NID</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="NID"
//                 value={formData.NID}
//                 onChange={(e) => setFormData({ ...formData, NID: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formDOB" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Date of Birth</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="dob"
//                 value={formData.dob}
//                 onChange={(e) => setFormData({ ...formData, dob: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formGender" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Gender</Form.Label>
//               <Form.Select
//                 name="gender"
//                 value={formData.gender}
//                 onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
//                 className="adminservitordetails-form-control"
//               >
//                 <option value="">Select Gender</option>
//                 <option value="Male">Male</option>
//                 <option value="Female">Female</option>
//                 <option value="Other">Other</option>
//               </Form.Select>
//             </Form.Group>

//             <Form.Group controlId="formService" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Service</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="service"
//                 value={formData.service}
//                 onChange={(e) => setFormData({ ...formData, service: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formCity" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">City</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="city"
//                 value={formData.city}
//                 onChange={(e) => setFormData({ ...formData, city: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formAddress" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Address</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="Address"
//                 value={formData.Address}
//                 onChange={(e) => setFormData({ ...formData, Address: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formExperience" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Experience (Years)</Form.Label>
//               <Form.Control
//                 type="number"
//                 name="experience"
//                 value={formData.experience}
//                 onChange={(e) => setFormData({ ...formData, experience: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formBio" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Bio</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={4}
//                 name="bio"
//                 value={formData.bio}
//                 onChange={(e) => setFormData({ ...formData, bio: e.target.value })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             <Form.Group controlId="formApproveStatus" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Status</Form.Label>
//               <Form.Select
//                 name="approve_status"
//                 value={formData.approve_status}
//                 onChange={(e) => setFormData({ ...formData, approve_status: e.target.value })}
//                 className="adminservitordetails-form-control"
//               >
//                 <option value="Pending">Pending</option>
//                 <option value="Approved">Approved</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Select>
//             </Form.Group>
//             <Form.Group controlId="formImage" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">Profile Picture</Form.Label>
//               <Form.Control
//                 type="file"
//                 name="image"
//                 accept=".jpg,.jpeg,.png,.webp"
//                 onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>


//             <Form.Group controlId="formDOC" className="mb-3">
//               <Form.Label className="adminservitordetails-form-label">NID Document</Form.Label>
//               <Form.Control
//                 type="file"
//                 name="certificate"
//                 accept=".pdf,.jpg,.jpeg,.png"
//                 onChange={(e) => setFormData({ ...formData, certificate: e.target.files[0] })}
//                 className="adminservitordetails-form-control"
//               />
//             </Form.Group>

//             {(formData.service === "Tutor Service" || formData.service === "Tutor") && (
//               <>
//                 <Form.Group controlId="formStudentIdCard" className="mb-3">
//                   <Form.Label className="adminservitordetails-form-label">Student ID Card</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="studentIdCard"
//                     accept=".pdf,.jpg,.jpeg,.png"
//                     onChange={(e) => setFormData({ ...formData, studentIdCard: e.target.files[0] })}
//                     className="adminservitordetails-form-control"
//                   />
//                 </Form.Group>

//                 <Form.Group controlId="formResume" className="mb-3">
//                   <Form.Label className="adminservitordetails-form-label">Resume</Form.Label>
//                   <Form.Control
//                     type="file"
//                     name="resume"
//                     accept=".pdf,.jpg,.jpeg,.png"
//                     onChange={(e) => setFormData({ ...formData, resume: e.target.files[0] })}
//                     className="adminservitordetails-form-control"
//                   />
//                 </Form.Group>
//               </>
//             )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminservitordetails-modal-footer">
//           <Button
//             variant="secondary"
//             onClick={() => setShowEditModal(false)}
//             className="adminservitordetails-footer-btn adminservitordetails-footer-btn-close"
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleUpdate}
//             className="adminservitordetails-footer-btn adminservitordetails-footer-btn-save"
//           >
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Image Preview Modal */}
//       <Modal
//         show={showImageModal}
//         onHide={() => setShowImageModal(false)}
//         centered
//         size="lg"
//         className="adminservitordetails-modal"
//       >
//         <Modal.Header closeButton className="adminservitordetails-modal-header">
//           <Modal.Title>Image Preview</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminservitordetails-modal-body text-center">
//           <Image src={imageSrc} alt="Preview" fluid />
//         </Modal.Body>
//       </Modal>
//     </Container>
//   );
// };

// export default ServitorDetails;




// ***** upper code is okay, Update with Auth protected (2-Dec-2025) ***** //
import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  InputGroup,
  Form,
  Table,
  Button,
  Modal,
  Alert,
  Pagination,
  Image,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import {
  FaPencilAlt,
  FaTrash,
  FaSearch,
  FaBolt,
  FaBroom,
  FaCogs,
  FaUserCheck,
  FaUserClock,
  FaEye,
  FaFire,
  FaSnowflake,
  FaFilter as FaFilterIcon,
  FaUserGraduate,
} from "react-icons/fa";
import "./ServitorDetails.css";
import { URL } from "../../../config";

/* ===========================
   ADMIN AUTH HELPER
   =========================== */
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  return adminToken ? { Authorization: `Bearer ${adminToken}` } : {};
};

/* ===========================
   FILE URL HELPERS
   =========================== */
// Build a safe file URL against /uploads
const fileUrl = (p) => {
  if (!p) return "";
  if (/^https?:\/\//i.test(p)) return p;
  const clean = p.startsWith("/") ? p : `/${p}`;
  return `${URL}${clean.startsWith("/uploads/") ? clean : `/uploads${clean}`}`;
};

const isPdf = (u) => /\.pdf(\?|#|$)/i.test(u || "");
const isImage = (u) =>
  /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(u || "");

const ServitorDetails = () => {
  // table data
  const [servitors, setServitors] = useState([]);
  // meta
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // filters & search
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("All"); // service
  const [filterStatus, setFilterStatus] = useState("All");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  // summary cards (from backend)
  const [summary, setSummary] = useState({
    total: 0,
    byService: {
      Electrician: 0,
      Plumber: 0,
      HomeCleaning: 0,
      GasChula: 0,
      ACService: 0,
      Filter: 0,
      TutorService: 0,
    },
    byStatus: { Approved: 0, Pending: 0, Blocked: 0 },
  });

  // view / edit modals
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [editServitor, setEditServitor] = useState(null);
  const [viewServitor, setViewServitor] = useState(null);

  const [creditAmount, setCreditAmount] = useState("");
  const [creditNote, setCreditNote] = useState("");
  const [creditLoading, setCreditLoading] = useState(false);

  const [debitAmount, setDebitAmount] = useState("");
  const [debitNote, setDebitNote] = useState("");
  const [debitLoading, setDebitLoading] = useState(false);

  // Active locations (dropdown data)
  const [divisions, setDivisions] = useState([]); // cities
  const [areas, setAreas] = useState([]);         // areas for selected city

  // Selected dropdown IDs (store IDs, but save names in DB)
  const [selectedDivisionId, setSelectedDivisionId] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");


  const [formData, setFormData] = useState({
    FirstName: "",
    LastName: "",
    email: "",
    mobile: "",
    NID: "",
    dob: "",
    gender: "",
    service: "",
    city: "",
    area: "",
    Address: "",
    experience: "",
    approve_status: "",
    balance: "",
    pendingCommission: "",
    bio: "",
    image: null,
    certificate: null, // NID document
    studentIdCard: null,
    resume: null,
  });

  const addQuick = (v) =>
    setCreditAmount((prev) => String((Number(prev) || 0) + v));

  const creditBalance = async () => {
    const amt = Number(creditAmount);
    if (!Number.isFinite(amt) || amt <= 0) {
      setErrorMessage("Enter a valid positive amount.");
      return;
    }
    if (!viewServitor) return;
    try {
      setCreditLoading(true);
      const resp = await axios.post(
        `${URL}/servitors/${viewServitor.Id}/credit`,
        {
          amount: amt,
          note: creditNote,
        },
        {
          headers: getAdminHeaders(),
        }
      );
      // update local + list
      const newBal = resp?.data?.newBalance ?? viewServitor.balance + amt;
      setViewServitor({ ...viewServitor, balance: newBal });
      setErrorMessage("Balance credited successfully.");
      setCreditAmount("");
      setCreditNote("");
      // refresh table & summary
      fetchServitors();
    } catch (e) {
      const msg =
        e?.response?.data?.error || "Failed to credit balance.";
      setErrorMessage(msg);
    } finally {
      setCreditLoading(false);
    }
  };


  // Servitor balance debit
  const addQuickDebit = (v) =>
  setDebitAmount((prev) => String((Number(prev) || 0) + v));

  const debitBalance = async () => {
    const amt = Number(debitAmount);
    if (!Number.isFinite(amt) || amt <= 0) {
      setErrorMessage("Enter a valid positive amount to deduct.");
      return;
    }
    if (!viewServitor) return;

    try {
      setDebitLoading(true);
      const resp = await axios.post(
        `${URL}/servitors/${viewServitor.Id}/debit`,
        { amount: amt, note: debitNote },
        { headers: getAdminHeaders() }
      );

      const newBal =
        resp?.data?.newBalance ?? (Number(viewServitor.balance || 0) - amt);

      setViewServitor({ ...viewServitor, balance: newBal });
      setErrorMessage("Balance deducted successfully.");
      setDebitAmount("");
      setDebitNote("");

      fetchServitors();
    } catch (e) {
      const msg = e?.response?.data?.error || "Failed to deduct balance.";
      setErrorMessage(msg);
    } finally {
      setDebitLoading(false);
    }
  };

  // -------- fetch helpers (server-side pagination) --------
  const fetchServitors = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        limit: itemsPerPage,
        sortBy: "Id",
        sortOrder: "DESC",
      };
      const st = searchTerm.trim();
      if (st) params.search = st;
      if (filterType !== "All") params.service = filterType;
      if (filterStatus !== "All") params.status = filterStatus;

      const resp = await axios.get(`${URL}/allservitors`, {
        params,
        headers: getAdminHeaders(),
      });
      const payload = resp.data || {};
      setServitors(payload.data || []);
      setTotalPages(payload.totalPages || 1);
      setTotal(payload.total || 0);
      if (payload.summary) setSummary(payload.summary);
      setErrorMessage("");
    } catch (err) {
      console.error("Error fetching servitors:", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Failed to fetch servitors.";
      setServitors([]);
      setTotal(0);
      setTotalPages(1);
      setErrorMessage(msg);
    } finally {
      setLoading(false);
    }
  };

  // initial + when page / filters change
  useEffect(() => {
    fetchServitors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filterType, filterStatus]);

  // debounce search
  useEffect(() => {
    const t = setTimeout(() => {
      setCurrentPage(1);
      fetchServitors();
    }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);


  // Load active divisions (cities)
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${URL}/locations/divisions?countryCode=BD`);
        setDivisions(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("Failed to load divisions:", e);
        setDivisions([]);
      }
    })();
  }, []);

  // Load active areas for selected division
  useEffect(() => {
    (async () => {
      if (!selectedDivisionId) {
        setAreas([]);
        setSelectedAreaId("");
        return;
      }
      try {
        const res = await axios.get(
          `${URL}/locations/areas?divisionId=${selectedDivisionId}`
        );
        setAreas(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("Failed to load areas:", e);
        setAreas([]);
        setSelectedAreaId("");
      }
    })();
  }, [selectedDivisionId]);


  const hasAcceptedTerms =
    !!viewServitor &&
    (viewServitor.termsAccepted === true ||
      viewServitor.termsAccepted === 1 ||
      viewServitor.termsAccepted === "1" ||
      viewServitor.termsAccepted === "true");

  // ---------- UI handlers ----------
  const handleImageClick = (src) => {
    setImageSrc(src);
    setShowImageModal(true);
  };

  const handleEdit = (servitor) => {
    setEditServitor(servitor);
    setFormData({
      FirstName: servitor.FirstName || "",
      LastName: servitor.LastName || "",
      email: servitor.email || "",
      mobile: servitor.mobile || "",
      NID: servitor.NID || "",
      dob: servitor.dob ? String(servitor.dob).split("T")[0] : "",
      gender: servitor.gender || "",
      service: servitor.service || "",
      city: servitor.city || "",
      area: servitor.area || "",
      Address: servitor.Address || "",
      experience: servitor.experience ?? "",
      pendingCommission: servitor.pendingCommission ?? "",
      approve_status: servitor.approve_status || "Pending",
      balance: servitor.balance ?? 0,
      bio: servitor.bio || "",
      certificate: null,
      studentIdCard: null,
      resume: null,
    });
    setShowEditModal(true);
  };


  // When edit modal opens, match saved city name -> divisionId
useEffect(() => {
  if (!showEditModal) return;
  if (!divisions.length) return;

  const matchedDiv = divisions.find(
    (d) =>
      String(d.name).toLowerCase() ===
      String(formData.city || "").toLowerCase()
  );

  const divId = matchedDiv ? String(matchedDiv.Id) : "";
  setSelectedDivisionId(divId);
}, [showEditModal, divisions, formData.city]);

  // When areas list loads, match saved area name -> areaId
  useEffect(() => {
    if (!showEditModal) return;
    if (!areas.length) return;

    const matchedArea = areas.find(
      (a) =>
        String(a.name).toLowerCase() ===
        String(formData.area || "").toLowerCase()
    );

    setSelectedAreaId(matchedArea ? String(matchedArea.Id) : "");
  }, [showEditModal, areas, formData.area]);


  const handleDivisionChange = (e) => {
    const id = e.target.value;

    setSelectedDivisionId(id);
    setSelectedAreaId("");
    setAreas([]);

    const div = divisions.find((d) => String(d.Id) === String(id));
    const cityName = div?.name || "";

    setFormData((prev) => ({
      ...prev,
      city: cityName,
      area: "",
    }));
  };

  const handleAreaChange = (e) => {
    const id = e.target.value;
    setSelectedAreaId(id);

    const ar = areas.find((a) => String(a.Id) === String(id));
    const areaName = ar?.name || "";

    setFormData((prev) => ({
      ...prev,
      area: areaName,
    }));
  };


  const closeEditModal = () => {
    setShowEditModal(false);
    setSelectedDivisionId("");
    setSelectedAreaId("");
    setAreas([]);
  };


  const handleView = (servitor) => {
    setViewServitor(servitor);
    setShowViewModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this servitor?"))
      return;
    try {
      await axios.delete(`${URL}/servitors/${id}`, {
        headers: getAdminHeaders(),
      });
      setErrorMessage("Servitor deleted successfully.");
      // Refresh current page (go back a page if last item removed)
      const isLastItemOnPage = servitors.length === 1 && currentPage > 1;
      if (isLastItemOnPage) setCurrentPage((p) => p - 1);
      else fetchServitors();
    } catch (error) {
      console.error("Error deleting servitor:", error);
      setErrorMessage("Failed to delete servitor. Please try again.");
    }
  };

  const handleUpdate = async () => {
    if (!editServitor) return;
    try {
      const form = new FormData();
      Object.entries(formData).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") form.append(k, v);
      });

      await axios.put(`${URL}/servitors/${editServitor.Id}`, form, {
        headers: {
          ...getAdminHeaders(),
          "Content-Type": "multipart/form-data",
        },
      });

      setShowEditModal(false);
      setErrorMessage("Servitor updated successfully.");
      fetchServitors();
    } catch (error) {
      console.error("Error updating servitor:", error);
      setErrorMessage("Failed to update servitor. Please try again.");
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // summary cards (from server totals)
  const electricianCount = summary.byService?.Electrician || 0;
  const plumberCount = summary.byService?.Plumber || 0;
  const homeCleaningCount = summary.byService?.HomeCleaning || 0;
  const gasChulaCount = summary.byService?.GasChula || 0;
  const acServiceCount = summary.byService?.ACService || 0;
  const filterCount = summary.byService?.Filter || 0;
  const tutorServiceCount = summary.byService?.TutorService || 0;

  const pendingCount = summary.byStatus?.Pending || 0;
  const approvedCount = summary.byStatus?.Approved || 0;

  // page numbers to render (compact)
  const pageItems = useMemo(() => {
    const maxButtons = 7;
    const pages = [];
    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, currentPage - siblings);
    let end = Math.min(totalPages - 1, currentPage + siblings);
    if (currentPage <= siblings + 2)
      end = Math.min(totalPages - 1, maxButtons - 1);
    if (currentPage >= totalPages - (siblings + 1))
      start = Math.max(2, totalPages - (maxButtons - 2));

    pages.push(1);
    if (start > 2) pages.push("…");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("…");
    pages.push(totalPages);
    return pages;
  }, [currentPage, totalPages]);

  return (
    <Container fluid className="adminservitordetails-container">
      {errorMessage && (
        <Alert
          variant={
            errorMessage.includes("successfully") ? "success" : "danger"
          }
          onClose={() => setErrorMessage("")}
          dismissible
          className="adminservitordetails-alert"
        >
          {errorMessage}
        </Alert>
      )}

      <Card className="adminservitordetails-card">
        <Card.Body>
          <Card.Header className="adminservitordetails-header">
            <h4 className="adminservitordetails-title">Servitor Details</h4>
          </Card.Header>

          {/* Summary Cards */}
          <div className="adminservitordetails-summary-cards">
            <div className="adminservitordetails-summary-card adminservitordetails-electrician-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Electricians
                </p>
                <p className="adminservitordetails-count-value">
                  {electricianCount}
                </p>
              </div>
              <FaBolt size={20} style={{ color: "#10b981" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-plumber-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Plumbers
                </p>
                <p className="adminservitordetails-count-value">
                  {plumberCount}
                </p>
              </div>
              <FaCogs size={20} style={{ color: "#3b82f6" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-home-cleaning-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Home Cleaning
                </p>
                <p className="adminservitordetails-count-value">
                  {homeCleaningCount}
                </p>
              </div>
              <FaBroom size={20} style={{ color: "#22c55e" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-gaschula-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Gas Chula
                </p>
                <p className="adminservitordetails-count-value">
                  {gasChulaCount}
                </p>
              </div>
              <FaFire size={20} style={{ color: "#ef4444" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-acservice-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total AC Service
                </p>
                <p className="adminservitordetails-count-value">
                  {acServiceCount}
                </p>
              </div>
              <FaSnowflake size={20} style={{ color: "#60a5fa" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-filter-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Filter
                </p>
                <p className="adminservitordetails-count-value">
                  {filterCount}
                </p>
              </div>
              <FaFilterIcon size={20} style={{ color: "#8b5cf6" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-tutor-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Tutor Service
                </p>
                <p className="adminservitordetails-count-value">
                  {tutorServiceCount}
                </p>
              </div>
              <FaUserGraduate size={20} style={{ color: "#2563eb" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-pending-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Pending
                </p>
                <p className="adminservitordetails-count-value">
                  {pendingCount}
                </p>
              </div>
              <FaUserClock size={20} style={{ color: "#f59e0b" }} />
            </div>

            <div className="adminservitordetails-summary-card adminservitordetails-approved-card">
              <div>
                <p className="adminservitordetails-detail-text">
                  Total Approved
                </p>
                <p className="adminservitordetails-count-value">
                  {approvedCount}
                </p>
              </div>
              <FaUserCheck size={20} style={{ color: "#10b981" }} />
            </div>
          </div>

          {/* Filters and Search */}
          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by name, mobile, service, city or area"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="adminservitordetails-search"
                />
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Group controlId="statusFilter">
                <Form.Select
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="adminservitordetails-filter-select"
                >
                  <option value="All">All Statuses</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Blocked">Blocked</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className="adminservitordetails-filter-container">
            {[
              "All",
              "Electrician",
              "Plumber",
              "Home Cleaning",
              "Gas Chula",
              "AC Service",
              "Filter",
              "Tutor Service",
            ].map((type) => (
              <Button
                key={type}
                variant={filterType === type ? "primary" : "outline-primary"}
                className="adminservitordetails-filter-btn"
                onClick={() => {
                  setFilterType(type);
                  setCurrentPage(1);
                }}
              >
                {type}
              </Button>
            ))}
          </div>

          {/* Table */}
          <div className="adminservitordetails-table-wrapper">
            <Table
              striped
              bordered
              hover
              responsive
              className="adminservitordetails-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Service</th>
                  <th>Balance</th>
                  <th>Servitor ID</th>
                  <th>Image</th>
                  <th>NID</th>
                  <th>DOC</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={10} style={{ textAlign: "center" }}>
                      <Spinner animation="border" />
                    </td>
                  </tr>
                ) : servitors.length === 0 ? (
                  <tr>
                    <td colSpan={10} style={{ textAlign: "center" }}>
                      No servitors found.
                    </td>
                  </tr>
                ) : (
                  servitors.map((servitor, index) => (
                    <tr key={servitor.Id}>
                      <td>
                        {index + 1 + (currentPage - 1) * itemsPerPage}
                      </td>
                      <td>{`${servitor.FirstName} ${servitor.LastName}`}</td>
                      <td>{servitor.mobile}</td>
                      <td>{servitor.service}</td>
                      <td>{servitor.balance ?? 0} Tk</td>
                      <td>{servitor.Id}</td>
                      <td>
                        <Image
                          src={
                            servitor.image
                              ? fileUrl(servitor.image)
                              : "/default-avatar.png"
                          }
                          alt={servitor.FirstName}
                          rounded
                          width="40"
                          height="40"
                          style={{
                            cursor: "pointer",
                            objectFit: "cover",
                          }}
                          onClick={() =>
                            handleImageClick(
                              servitor.image
                                ? fileUrl(servitor.image)
                                : "/default-avatar.png"
                            )
                          }
                        />
                      </td>
                      <td>
                        {servitor.DOC ? (
                          <a
                            href={fileUrl(servitor.DOC)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i
                              className="bi bi-file-earmark-pdf"
                              style={{
                                fontSize: "1.2rem",
                                color: "#ef4444",
                              }}
                            ></i>
                          </a>
                        ) : (
                          <i
                            className="bi bi-file-earmark"
                            style={{
                              fontSize: "1.2rem",
                              color: "#6b7280",
                            }}
                          >
                            N/A
                          </i>
                        )}
                      </td>
                      <td>
                        {servitor.tutorProfile?.resume ? (
                          <a
                            href={fileUrl(servitor.tutorProfile?.resume)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i
                              className="bi bi-file-earmark-pdf"
                              style={{
                                fontSize: "1.2rem",
                                color: "#ef4444",
                              }}
                            ></i>
                          </a>
                        ) : (
                          <i
                            className="bi bi-file-earmark"
                            style={{
                              fontSize: "1.2rem",
                              color: "#6b7280",
                            }}
                          >
                            N/A
                          </i>
                        )}
                      </td>
                      <td>
                        <span
                          className={`adminservitordetails-badge-${String(
                            servitor.approve_status || ""
                          ).toLowerCase()}`}
                        >
                          {servitor.approve_status}
                        </span>
                      </td>
                      <td>
                        <div className="adminservitordetails-action-group">
                          <Button
                            variant="outline-info"
                            size="sm"
                            className="adminservitordetails-action-btn"
                            onClick={() => handleView(servitor)}
                          >
                            <FaEye size={16} />
                          </Button>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="adminservitordetails-action-btn"
                            onClick={() => handleEdit(servitor)}
                          >
                            <FaPencilAlt size={16} />
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="adminservitordetails-action-btn"
                            onClick={() => handleDelete(servitor.Id)}
                          >
                            <FaTrash size={16} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          {/* Pagination */}
          <Pagination className="adminservitordetails-pagination">
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1 || loading}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1 || loading}
            />

            {pageItems.map((p, idx) =>
              p === "…" ? (
                <Pagination.Ellipsis key={`e-${idx}`} disabled />
              ) : (
                <Pagination.Item
                  key={p}
                  active={p === currentPage}
                  onClick={() => handlePageChange(p)}
                  disabled={loading}
                >
                  {p}
                </Pagination.Item>
              )
            )}

            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || loading}
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages || loading}
            />
          </Pagination>

          <div className="adminservitordetails-total-hint">
            Showing page {currentPage} of {totalPages} — {total} total
          </div>
        </Card.Body>
      </Card>

      {/* View Servitor Modal */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        centered
        size="lg"
        className="adminservitordetails-Viewmodal"
      >
        <Modal.Header className="adminservitordetails-Viewmodal-header" closeButton>
          <div className="adminservitordetails-Viewmodal-header-content">
            <Modal.Title className="adminservitordetails-Viewmodal-title">
              Servitor Details
            </Modal.Title>
            <p className="adminservitordetails-Viewmodal-subtitle">
              {viewServitor?.FirstName} {viewServitor?.LastName}
            </p>
          </div>
        </Modal.Header>
        <Modal.Body className="adminservitordetails-Viewmodal-body">
          {viewServitor && (
            <>
              <div className="adminservitordetails-Viewmodal-profile">
                <div className="adminservitordetails-Viewmodal-avatar">
                  {viewServitor.FirstName?.charAt(0)}
                  {viewServitor.LastName?.charAt(0)}
                </div>
                <div className="adminservitordetails-Viewmodal-profile-info">
                  <h3 className="adminservitordetails-Viewmodal-name">
                    {viewServitor.FirstName} {viewServitor.LastName}
                  </h3>
                  <div className="adminservitordetails-Viewmodal-badges">
                    <span
                      className={`adminservitordetails-Viewmodal-badge ${
                        viewServitor.approve_status === "Approved"
                          ? "approved"
                          : viewServitor.approve_status === "Pending"
                          ? "pending"
                          : "blocked"
                      }`}
                    >
                      {viewServitor.approve_status}
                    </span>
                    <span className="adminservitordetails-Viewmodal-badge experience">
                      {viewServitor.experience} year Experience
                    </span>
                  </div>
                </div>
              </div>

              <div className="adminservitordetails-Viewmodal-details-grid">
                <div className="adminservitordetails-Viewmodal-section">
                  <h4 className="adminservitordetails-Viewmodal-section-title">
                    <i
                      className="bi bi-person"
                      style={{ marginRight: 8, color: "#8B5CF6" }}
                    ></i>
                    Personal Information
                  </h4>
                  <div className="adminservitordetails-Viewmodal-section-content">
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Servitor ID
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.Id}
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Gender
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.gender}
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Experience
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.experience} year
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        NID
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.NID}
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        City
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.city}
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Area
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.area}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="adminservitordetails-Viewmodal-section">
                  <h4 className="adminservitordetails-Viewmodal-section-title">
                    <i
                      className="bi bi-geo-alt"
                      style={{ marginRight: 8, color: "#8B5CF6" }}
                    ></i>
                    Contact & Balance
                  </h4>
                  <div className="adminservitordetails-Viewmodal-section-content">
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Balance
                      </span>
                      <span className="adminservitordetails-Viewmodal-value balance">
                        {viewServitor.balance || 0} Tk
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Phone
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.mobile}
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Email
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {viewServitor.email}
                      </span>
                    </div>
                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        Join Date
                      </span>
                      <span className="adminservitordetails-Viewmodal-value">
                        {new Date(
                          viewServitor.created_at
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </span>
                    </div>

                    <div className="adminservitordetails-Viewmodal-detail-item">
                      <span className="adminservitordetails-Viewmodal-label">
                        HelpNao Servitor Terms
                      </span>
                      <span
                        className={
                          "adminservitordetails-Viewmodal-value " +
                          (hasAcceptedTerms
                            ? "adminservitordetails-terms-accepted"
                            : "adminservitordetails-terms-notaccepted")
                        }
                      >
                        {hasAcceptedTerms ? "Accepted" : "N/A"}
                      </span>
                    </div>

                    {Number(viewServitor?.pin_fail_count || 0) > 0 && (
                      <div className="adminservitordetails-Viewmodal-detail-item">
                        <span className="adminservitordetails-Viewmodal-label">
                          Wrong PIN Attempts
                        </span>
                        <span className="adminservitordetails-Viewmodal-value pin-fails">
                          <span
                            className="pin-fails-dot"
                            aria-hidden="true"
                          />
                          {Number(viewServitor.pin_fail_count)} time
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="adminservitordetails-Viewmodal-full-section">
                <h4 className="adminservitordetails-Viewmodal-section-title">
                  <i
                    className="bi bi-house"
                    style={{ marginRight: 8, color: "#8B5CF6" }}
                  ></i>
                  Address
                </h4>
                <div className="adminservitordetails-Viewmodal-address-content">
                  {viewServitor.Address}
                </div>
              </div>

              <div className="adminservitordetails-Viewmodal-full-section">
                <h4 className="adminservitordetails-Viewmodal-section-title">
                  <i
                    className="bi bi-file-text"
                    style={{ marginRight: 8, color: "#8B5CF6" }}
                  ></i>
                  Bio
                </h4>
                <div className="adminservitordetails-Viewmodal-bio-content">
                  {viewServitor.bio || "N/A"}
                </div>
              </div>

              {/* Admin credit control */}
              <div
                className="adminservitordetails-Viewmodal-detail-item"
                style={{ display: "block", marginTop: 12 }}
              >
                <span
                  className="adminservitordetails-Viewmodal-label"
                  style={{ display: "block", marginBottom: 6 }}
                >
                  Admin Credit (Increase Only)
                </span>

                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <Form.Control
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Amount"
                    value={creditAmount}
                    onChange={(e) => setCreditAmount(e.target.value)}
                    style={{ width: 140 }}
                  />

                  <div style={{ display: "flex", gap: 6 }}>
                    {[50, 100, 200, 500].map((v) => (
                      <Button
                        key={v}
                        size="sm"
                        variant="outline-success"
                        onClick={() => addQuick(v)}
                      >
                        +{v}
                      </Button>
                    ))}
                  </div>

                  <Button
                    variant="success"
                    size="sm"
                    disabled={creditLoading}
                    onClick={creditBalance}
                    title="Add to Servitor balance and record as bonus transaction"
                  >
                    {creditLoading ? (
                      <Spinner size="sm" animation="border" />
                    ) : (
                      "Add Balance"
                    )}
                  </Button>
                </div>

                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Optional note (e.g., emergency support, dispute resolution)"
                  value={creditNote}
                  onChange={(e) => setCreditNote(e.target.value)}
                  style={{ marginTop: 8 }}
                />
              </div>



              {/* Admin debit control */}
                <div
                  className="adminservitordetails-Viewmodal-detail-item"
                  style={{ display: "block", marginTop: 14 }}
                >
                  <span
                    className="adminservitordetails-Viewmodal-label"
                    style={{ display: "block", marginBottom: 6 }}
                  >
                    Admin Deduct (Decrease Only)
                  </span>

                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <Form.Control
                      type="number"
                      min="1"
                      step="1"
                      placeholder="Amount"
                      value={debitAmount}
                      onChange={(e) => setDebitAmount(e.target.value)}
                      style={{ width: 140 }}
                    />

                    <div style={{ display: "flex", gap: 6 }}>
                      {[50, 100, 200, 500].map((v) => (
                        <Button
                          key={v}
                          size="sm"
                          variant="outline-danger"
                          onClick={() => addQuickDebit(v)}
                        >
                          -{v}
                        </Button>
                      ))}
                    </div>

                    <Button
                      variant="danger"
                      size="sm"
                      disabled={debitLoading}
                      onClick={debitBalance}
                      title="Deduct from Servitor balance and record as debit transaction"
                    >
                      {debitLoading ? <Spinner size="sm" animation="border" /> : "Deduct Balance"}
                    </Button>
                  </div>

                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Optional note (e.g., penalty, wrong withdrawal, dispute adjustment)"
                    value={debitNote}
                    onChange={(e) => setDebitNote(e.target.value)}
                    style={{ marginTop: 8 }}
                  />
                </div>


              {(viewServitor?.service === "Tutor Service" ||
                viewServitor?.service === "Tutor" ||
                viewServitor?.tutorProfile) && (
                <div className="adminservitordetails-Viewmodal-full-section">
                  <h4 className="adminservitordetails-Viewmodal-section-title">
                    <i
                      className="bi bi-mortarboard"
                      style={{ marginRight: 8, color: "#8B5CF6" }}
                    ></i>
                    Tutor Verification
                  </h4>

                  <div
                    className="adminservitordetails-Viewmodal-details-grid"
                    style={{ marginTop: 8 }}
                  >
                    <div className="adminservitordetails-Viewmodal-section">
                      <div className="adminservitordetails-Viewmodal-section-content">
                        <div className="adminservitordetails-Viewmodal-detail-item">
                          <span className="adminservitordetails-Viewmodal-label">
                            University Type
                          </span>
                          <span className="adminservitordetails-Viewmodal-value">
                            {viewServitor?.tutorProfile?.universityType ||
                              "N/A"}
                          </span>
                        </div>
                        <div className="adminservitordetails-Viewmodal-detail-item">
                          <span className="adminservitordetails-Viewmodal-label">
                            University Name
                          </span>
                          <span className="adminservitordetails-Viewmodal-value">
                            {viewServitor?.tutorProfile?.universityName ||
                              "N/A"}
                          </span>
                        </div>
                        <div className="adminservitordetails-Viewmodal-detail-item">
                          <span className="adminservitordetails-Viewmodal-label">
                            Major
                          </span>
                          <span className="adminservitordetails-Viewmodal-value">
                            {viewServitor?.tutorProfile?.major || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="adminservitordetails-Viewmodal-section">
                      <div className="adminservitordetails-Viewmodal-section-content">
                        <div
                          className="adminservitordetails-Viewmodal-detail-item"
                          style={{ display: "block" }}
                        >
                          <span
                            className="adminservitordetails-Viewmodal-label"
                            style={{
                              display: "block",
                              marginBottom: 8,
                            }}
                          >
                            Student ID Card
                          </span>

                          {(() => {
                            const raw =
                              viewServitor?.tutorProfile?.studentIdCard;
                            const u = fileUrl(raw);
                            if (!raw)
                              return (
                                <span className="adminservitordetails-Viewmodal-value">
                                  N/A
                                </span>
                              );

                            if (isImage(u)) {
                              return (
                                <a
                                  href={u}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="adminservitordetails-studentid-thumb"
                                  title="Open image in a new tab"
                                >
                                  <img src={u} alt="Student ID" />
                                </a>
                              );
                            }

                            if (isPdf(u)) {
                              return (
                                <div className="adminservitordetails-studentid-pdf">
                                  <iframe
                                    src={u}
                                    title="Student ID PDF"
                                    className="adminservitordetails-studentid-iframe"
                                  />
                                  <a
                                    href={u}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="adminservitordetails-Viewmodal-value"
                                    style={{
                                      display: "inline-block",
                                      marginTop: 8,
                                    }}
                                  >
                                    Open in new tab
                                  </a>
                                </div>
                              );
                            }

                            return (
                              <a
                                href={u}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="adminservitordetails-Viewmodal-value"
                              >
                                Open Student ID
                              </a>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="adminservitordetails-Viewmodal-footer">
          <Button
            variant="warning"
            className="adminservitordetails-Viewmodal-edit-btn"
            onClick={() => {
              setShowViewModal(false);
              if (viewServitor) handleEdit(viewServitor);
            }}
          >
            <i className="bi bi-pencil" style={{ marginRight: 6 }}></i>
            Edit
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowViewModal(false)}
            className="adminservitordetails-Viewmodal-close-btn"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Servitor Modal */}
      <Modal
        show={showEditModal}
        onHide={closeEditModal}
        centered
        className="adminservitordetails-modal"
      >
        <Modal.Header
          closeButton
          className="adminservitordetails-modal-header"
        >
          <Modal.Title>Edit Servitor</Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminservitordetails-modal-body">
          <Form>
            <Form.Group controlId="formFirstName" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                First Name
              </Form.Label>
              <Form.Control
                type="text"
                name="FirstName"
                value={formData.FirstName}
                onChange={(e) =>
                  setFormData({ ...formData, FirstName: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formLastName" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Last Name
              </Form.Label>
              <Form.Control
                type="text"
                name="LastName"
                value={formData.LastName}
                onChange={(e) =>
                  setFormData({ ...formData, LastName: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Email
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formMobile" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Mobile
              </Form.Label>
              <Form.Control
                type="number"
                name="mobile"
                value={formData.mobile}
                onChange={(e) =>
                  setFormData({ ...formData, mobile: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formNID" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                NID
              </Form.Label>
              <Form.Control
                type="number"
                name="NID"
                value={formData.NID}
                onChange={(e) =>
                  setFormData({ ...formData, NID: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formDOB" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Date of Birth
              </Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={formData.dob}
                onChange={(e) =>
                  setFormData({ ...formData, dob: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formGender" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Gender
              </Form.Label>
              <Form.Select
                name="gender"
                value={formData.gender}
                onChange={(e) =>
                  setFormData({ ...formData, gender: e.target.value })
                }
                className="adminservitordetails-form-control"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="formService" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Service
              </Form.Label>
              <Form.Control
                type="text"
                name="service"
                value={formData.service}
                onChange={(e) =>
                  setFormData({ ...formData, service: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formPendingCommission" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Balance
              </Form.Label>
              <Form.Control
                type="number"
                name="balance"
                value={formData.balance ?? ""}
                onChange={(e) =>
                  setFormData({ ...formData, balance: e.target.value })
                }
                className="adminservitordetails-form-control"
                min="0"
                step="1"
              />
            </Form.Group>
            
            <Form.Group controlId="formPendingCommission" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Pending Commission
              </Form.Label>
              <Form.Control
                type="number"
                name="pendingCommission"
                value={formData.pendingCommission ?? ""}
                onChange={(e) =>
                  setFormData({ ...formData, pendingCommission: e.target.value })
                }
                className="adminservitordetails-form-control"
                min="0"
                step="1"
              />
            </Form.Group>


            <Form.Group controlId="formCity" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">City</Form.Label>

              <InputGroup>
                <Form.Select
                  value={selectedDivisionId}
                  onChange={handleDivisionChange}
                  className="adminservitordetails-form-control"
                >
                  <option value="">Select City</option>
                  {divisions.map((d) => (
                    <option key={d.Id} value={d.Id}>
                      {d.name}
                    </option>
                  ))}
                </Form.Select>

                <InputGroup.Text>
                  <i className="bi bi-chevron-down" />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <Form.Group controlId="formArea" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Area
              </Form.Label>

              <InputGroup>
                <Form.Select
                  value={selectedAreaId}
                  onChange={handleAreaChange}
                  disabled={!selectedDivisionId}
                  className="adminservitordetails-form-control"
                >
                  <option value="">
                    {selectedDivisionId ? "Select Area" : "Select City first"}
                  </option>

                  {areas.map((a) => (
                    <option key={a.Id} value={a.Id}>
                      {a.name}
                    </option>
                  ))}
                </Form.Select>

                <InputGroup.Text>
                  <i className="bi bi-chevron-down" />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>




            <Form.Group controlId="formAddress" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Address
              </Form.Label>
              <Form.Control
                type="text"
                name="Address"
                value={formData.Address}
                onChange={(e) =>
                  setFormData({ ...formData, Address: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formExperience" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Experience (Years)
              </Form.Label>
              <Form.Control
                type="number"
                name="experience"
                value={formData.experience}
                onChange={(e) =>
                  setFormData({ ...formData, experience: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formBio" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Bio
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="bio"
                value={formData.bio}
                onChange={(e) =>
                  setFormData({ ...formData, bio: e.target.value })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formApproveStatus" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Status
              </Form.Label>
              <Form.Select
                name="approve_status"
                value={formData.approve_status}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    approve_status: e.target.value,
                  })
                }
                className="adminservitordetails-form-control"
              >
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Blocked">Blocked</option>
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="formImage" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                Profile Picture
              </Form.Label>
              <Form.Control
                type="file"
                name="image"
                accept=".jpg,.jpeg,.png,.webp"
                onChange={(e) =>
                  setFormData({ ...formData, image: e.target.files[0] })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            <Form.Group controlId="formDOC" className="mb-3">
              <Form.Label className="adminservitordetails-form-label">
                NID Document
              </Form.Label>
              <Form.Control
                type="file"
                name="certificate"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    certificate: e.target.files[0],
                  })
                }
                className="adminservitordetails-form-control"
              />
            </Form.Group>

            {(formData.service === "Tutor Service" ||
              formData.service === "Tutor") && (
              <>
                <Form.Group
                  controlId="formStudentIdCard"
                  className="mb-3"
                >
                  <Form.Label className="adminservitordetails-form-label">
                    Student ID Card
                  </Form.Label>
                  <Form.Control
                    type="file"
                    name="studentIdCard"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        studentIdCard: e.target.files[0],
                      })
                    }
                    className="adminservitordetails-form-control"
                  />
                </Form.Group>

                <Form.Group controlId="formResume" className="mb-3">
                  <Form.Label className="adminservitordetails-form-label">
                    Resume
                  </Form.Label>
                  <Form.Control
                    type="file"
                    name="resume"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        resume: e.target.files[0],
                      })
                    }
                    className="adminservitordetails-form-control"
                  />
                </Form.Group>
              </>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer className="adminservitordetails-modal-footer">
          <Button
            variant="secondary"
            onClick={() => setShowEditModal(false)}
            className="adminservitordetails-footer-btn adminservitordetails-footer-btn-close"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleUpdate}
            className="adminservitordetails-footer-btn adminservitordetails-footer-btn-save"
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Image Preview Modal */}
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="lg"
        className="adminservitordetails-modal"
      >
        <Modal.Header
          closeButton
          className="adminservitordetails-modal-header"
        >
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminservitordetails-modal-body text-center">
          <Image src={imageSrc} alt="Preview" fluid />
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ServitorDetails;
